webpackJsonp([8],{

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export apiCallReal */
/* unused harmony export getResource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return apiCall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_vue__ = __webpack_require__(39);





var apiCallReal = function apiCallReal(_ref) {
  var url = _ref.url,
      _ref$method = _ref.method,
      method = _ref$method === undefined ? 'GET' : _ref$method,
      _ref$data = _ref.data,
      data = _ref$data === undefined ? {} : _ref$data,
      _ref$extraHeader = _ref.extraHeader,
      extraHeader = _ref$extraHeader === undefined ? {} : _ref$extraHeader;

  var headerByDefault = { 'Content-Type': 'application/json' };
  var headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, headerByDefault, extraHeader);
  var endpoint = "https://chi-manager.com" + url;
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: endpoint, data: data, method: method, headers: headers }).then(function (resp) {
      resolve(resp.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3__sentry_vue__["a" /* captureException */](error);
      reject(error);
    });
  });
};

var getResource = function getResource(_ref2) {
  var url = _ref2.url,
      _ref2$method = _ref2.method,
      method = _ref2$method === undefined ? 'GET' : _ref2$method,
      _ref2$data = _ref2.data,
      data = _ref2$data === undefined ? {} : _ref2$data,
      _ref2$extraHeader = _ref2.extraHeader,
      extraHeader = _ref2$extraHeader === undefined ? {} : _ref2$extraHeader;

  var headerByDefault = { 'Content-Type': 'application/json' };
  var headers = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, headerByDefault, extraHeader);
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: url, data: data, method: method, headers: headers }).then(function (resp) {
      resolve(resp.data);
    }).catch(function (error) {
      __WEBPACK_IMPORTED_MODULE_3__sentry_vue__["a" /* captureException */](error);
      reject(error);
    });
  });
};

var apiCall = function apiCall(_ref3) {
  var url = _ref3.url,
      _ref3$method = _ref3.method,
      method = _ref3$method === undefined ? 'GET' : _ref3$method,
      _ref3$data = _ref3.data,
      data = _ref3$data === undefined ? {} : _ref3$data,
      _ref3$extraHeader = _ref3.extraHeader,
      extraHeader = _ref3$extraHeader === undefined ? {} : _ref3$extraHeader;

  return apiCallReal({ url: url, method: method, data: data, extraHeader: extraHeader });
};

/* unused harmony default export */ var _unused_webpack_default_export = ({ apiCall: apiCall });

/***/ }),

/***/ 136:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_header__ = __webpack_require__(417);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_footer__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_ReloadRequired__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_ConnectingLoader__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_Onboarding__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_ActiveNotification__ = __webpack_require__(676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__chi_x_chi_login_lib_actions__ = __webpack_require__(400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__analytics__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_navigation_HomeNavigation__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_navigation_NotificationsNavigation__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_navigation_ProfileNavigation__ = __webpack_require__(684);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__router__ = __webpack_require__(57);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["a"] = ({
  store: __WEBPACK_IMPORTED_MODULE_13__store__["a" /* default */],
  data: function data() {
    return {
      isHomeMounted: false,
      isProfileMounted: false,
      isNotiMounted: false,
      badgeNumber: 0,
      authFinished: false,
      scrollPos: {},
      viewStateName: false
    };
  },
  components: {
    'main-header': __WEBPACK_IMPORTED_MODULE_1__components_header__["a" /* default */],
    'main-footer': __WEBPACK_IMPORTED_MODULE_2__components_footer__["a" /* default */],
    ReloadRequired: __WEBPACK_IMPORTED_MODULE_3__components_ReloadRequired__["a" /* default */],
    ConnectingLoader: __WEBPACK_IMPORTED_MODULE_4__views_ConnectingLoader__["a" /* default */],
    HomeNavigation: __WEBPACK_IMPORTED_MODULE_14__components_navigation_HomeNavigation__["a" /* default */],
    NotificationsNavigation: __WEBPACK_IMPORTED_MODULE_15__components_navigation_NotificationsNavigation__["a" /* default */],
    ProfileNavigation: __WEBPACK_IMPORTED_MODULE_16__components_navigation_ProfileNavigation__["a" /* default */],
    onboarding: __WEBPACK_IMPORTED_MODULE_5__views_Onboarding__["a" /* default */],
    'active-notifications': __WEBPACK_IMPORTED_MODULE_6__views_ActiveNotification__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    var current = this;
    this.firebaseAuthHandler().then(function (data) {
      if (!__WEBPACK_IMPORTED_MODULE_11_vue_underscore__["a" /* _ */].isEmpty(data)) {
        var isMuted = _this.$store.getters.getMuted ? 'chi_video_mute' : 'chi_video_unmute';
        Object(__WEBPACK_IMPORTED_MODULE_12__analytics__["a" /* RegisterEvent */])('chi_user_login', {
          target_id: data.uid,
          target_type: 'user_id'
        });
        Object(__WEBPACK_IMPORTED_MODULE_12__analytics__["a" /* RegisterEvent */])(isMuted, {
          target_id: 'chi_login',
          target_type: 'global_event'
        });
        _this.profileAction();
      }
      current.authFinished = true;
    }).catch(function (error) {
      return console.log(error);
    });
    var target = this;
    window.addEventListener('ReactNativeMessage', function (e) {
      target.saveDevice(e.detail);
    });
    var showNewVersionModal = this.showNewVersionModal;
    window.addEventListener('pwaNewVersionDetected', function (e) {
      showNewVersionModal();
    }, false);

    var url = window.location.pathname + window.location.search;
    if (url !== '' || url !== '/') {
      var resolved = __WEBPACK_IMPORTED_MODULE_17__router__["d" /* router */].resolve(url);
      if (undefined !== resolved.route.name) {
        __WEBPACK_IMPORTED_MODULE_17__router__["d" /* router */].push(resolved.route);
        this.ActiveHomeNav();
      } else {
        resolved = __WEBPACK_IMPORTED_MODULE_17__router__["a" /* NotificationNavRouter */].resolve(url);
        if (undefined !== resolved.route.name) {
          __WEBPACK_IMPORTED_MODULE_17__router__["a" /* NotificationNavRouter */].push(resolved.route);
          this.ActiveNotifNav();
        } else {
          resolved = __WEBPACK_IMPORTED_MODULE_17__router__["b" /* ProfileNavRouter */].resolve(url);
          if (undefined !== resolved.route.name) {
            __WEBPACK_IMPORTED_MODULE_17__router__["b" /* ProfileNavRouter */].push(resolved.route);
            this.ActiveProfileNav();
          }
        }
      }
    } else {
      this.ActiveHomeNav();
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["c" /* mapGetters */])(['isAuthenticated', 'firebaseUUID', 'getBadgeNotif', 'getCheckedBadge', 'getProfileData', 'getDeviceInfo', 'isHomeNavActive', 'isNotificationNavActive', 'isProfileNavActive', 'getActiveNav', 'getDocumentTitleName']), {
    HeaderTitle: function HeaderTitle() {
      // console.log(this.getDocumentTitleName, 'titleName')
      return this.getCurrentRoute.meta && this.getCurrentRoute.meta.titleName ? this.getCurrentRoute.meta.titleName(this.getCurrentRoute) : undefined;
    },

    getCurrentNav: function getCurrentNav() {
      if (this.isHomeMounted && this.isHomeNavActive) return this.$refs.homeNav;
      if (this.isNotiMounted && this.isNotificationNavActive) {
        return this.$refs.notificationNav;
      }
      if (this.isProfileMounted && this.isProfileNavActive) {
        return this.$refs.profileNav;
      }
      return undefined;
    },
    getCurrentRoute: function getCurrentRoute() {
      return this.getCurrentNav ? this.getCurrentNav.$route : {};
    },
    isConnecting: function isConnecting() {
      // return !this.authFinished
      return this.isLoading && !this.authFinished;
      // return !this.authFinishedthis.isAuthenticated()
    },
    isOnBoarding: function isOnBoarding() {
      return this.$store.getters.getProfileData.onboarding;
    },
    isLoading: function isLoading() {
      return !(this.isHomeMounted && this.isNotiMounted && this.isProfileMounted);
    },
    isActiveNotif: function isActiveNotif() {
      var showActiveNotifView = false;
      var isAuthenticated = this.isAuthenticated();
      var activeNotification = this.$store.getters.getProfileData.active_notification;
      if (__WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__["b" /* isApp */] && isAuthenticated && activeNotification) {
        var device = this.$store.getters.getDeviceInfo();
        var status = (device.pushNotifStatus || '').toUpperCase();
        var numDays = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["c" /* daysFrom */])(device.pushNotifUpdatedAt);
        switch (status) {
          case 'UNAVAILABLE':
            showActiveNotifView = false;
            break;
          case 'DENIED':
            showActiveNotifView = true;
            break;
          case 'LIMITED':
            showActiveNotifView = true;
            break;
          case 'GRANTED':
            showActiveNotifView = false;
            break;
          case 'BLOCKED':
            showActiveNotifView = numDays > 14;
            break;
          case 'NONE':
            showActiveNotifView = numDays > 0;
            break;
        }
      }
      return showActiveNotifView;
    },
    viewState: function viewState() {
      var viewState = this.viewStateName;
      if (this.requiresAuth && !this.firebaseUUID) {
        viewState = 'none';
      }
      if (this.isAuthenticated()) {
        if (!viewState && this.isConnecting) viewState = 'connecting';
        if (!viewState && this.isOnBoarding) viewState = 'onboarding';
        if (!viewState && this.isActiveNotif) viewState = 'active-notification';
        if (!viewState) viewState = 'main-content';
      }
      if (!viewState) viewState = 'none';
      return viewState;
    },
    requiresAuth: function requiresAuth() {
      if (this.getCurrentRoute && this.getCurrentRoute.meta) {
        var required = this.getCurrentRoute.meta.requiresAuth;
        if (required && !this.firebaseUUID) {
          this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_7__chi_x_chi_login_lib_actions__["a" /* default */].AUTH_LOGOUT);
        }
        // if (required && this.firebaseUUID) {
        if (this.isAuthenticated() && required && this.firebaseUUID) {
          !this.getCheckedBadge && this.calcBadge();
        }
      }
      return false; // required
    },
    showMainViews: function showMainViews() {
      return this.viewState === 'none' || this.viewState === 'main-content';
    },
    showHeader: function showHeader() {
      return this.viewState === 'main-content';
    },
    showMenu: function showMenu() {
      return this.viewState === 'main-content';
    },
    showConnecting: function showConnecting() {
      return this.viewState === 'connecting';
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["b" /* mapActions */])({
    showNewVersionModal: 'NEW_VERSION_DETECTED',
    firebaseAuthHandler: 'FIREBASE_ACCESS',
    saveDeviceAction: 'DEVICE_ACTION',
    profileAction: 'GET_PROFILE',
    forceSSLAction: 'GET_FORCE_SSL',
    ActiveHomeNav: 'CHANGE_HOME_NAV',
    ActiveNotifNav: 'CHANGE_NOTIFICATIONS_NAV',
    ActiveProfileNav: 'CHANGE_PROFILE_NAV',
    calcBadge: 'CALC_BADGE'
  }), {
    saveDevice: function saveDevice(param) {
      this.saveDeviceAction(param);
    },
    homeLoaded: function homeLoaded() {
      if (__WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__["b" /* isApp */] && this.viewState === 'main-content') this.isHomeMounted = true;else if (!__WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__["b" /* isApp */] && this.showMainViews) this.isHomeMounted = true;
    },
    notiLoaded: function notiLoaded() {
      this.isNotiMounted = true;
    },
    profileLoaded: function profileLoaded() {
      this.isProfileMounted = true;
    },
    viewStateCancelPushNotif: function viewStateCancelPushNotif() {
      this.viewStateName = 'main-content';
    },
    resetMenuClick: function resetMenuClick(navName) {
      if (this.getActiveNav === navName) {
        this.getCurrentNav.mainSite();
      }
    },
    clickBackEvent: function clickBackEvent() {
      if (this.getCurrentNav) {
        if (this.getCurrentNav.$router.history.index === 0) {
          this.getCurrentNav.mainSite();
        } else this.getCurrentNav.$router.back();
        Object(__WEBPACK_IMPORTED_MODULE_12__analytics__["a" /* RegisterEvent */])('chi_go_back', {
          target_id: this.getCurrentNav.$router.currentRoute.name,
          from: this.getCurrentNav.$router.currentRoute.path,
          target_type: 'screen_name'
        });
      }
    },
    registerEventMenuSelected: function registerEventMenuSelected(menuName) {
      Object(__WEBPACK_IMPORTED_MODULE_12__analytics__["a" /* RegisterEvent */])('chi_menu_selected', {
        target_id: menuName
      });
    },
    clickEventHome: function clickEventHome() {
      var _this2 = this;

      this.scrollPos[this.getActiveNav] = window.scrollY;
      if (this.getActiveNav === 'home') {
        this.resetMenuClick(this.getActiveNav);
      } else {
        this.ActiveHomeNav().then(function () {
          window.scrollTo(0, _this2.scrollPos.home);
          _this2.registerEventMenuSelected('home');
        });
      }
    },
    clickEventNotifications: function clickEventNotifications() {
      var _this3 = this;

      this.scrollPos[this.getActiveNav] = window.scrollY;
      if (this.getActiveNav === 'notifications') {
        this.resetMenuClick(this.getActiveNav);
      } else {
        this.ActiveNotifNav().then(function () {
          window.scrollTo(0, _this3.scrollPos.notifications);
          _this3.registerEventMenuSelected('notifications');
        });
      }
    },
    clickEventProfile: function clickEventProfile() {
      var _this4 = this;

      this.scrollPos[this.getActiveNav] = window.scrollY;
      if (this.getActiveNav === 'profile') {
        this.resetMenuClick(this.getActiveNav);
      } else {
        this.ActiveProfileNav().then(function () {
          window.scrollTo(0, _this4.scrollPos.profile);
          _this4.registerEventMenuSelected('profile');
        });
      }
    }
  }),
  mounted: function mounted() {
    this.forceSSLAction();
  }
});

/***/ }),

/***/ 142:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainHeader',
  props: {
    showHeader: Boolean,
    headerTitle: String,
    onClick: Function
  },
  computed: {
    styles: function styles() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_0__helper_helper__["b" /* convertEmToPixels */])(16);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    }
  }
});

/***/ }),

/***/ 20:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return limitRefDB; });
/* unused harmony export sliceNumberDB */
/* unused harmony export db */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return postsDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return notifDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return userDB; });
/* unused harmony export likesDB */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return changesDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return settingsDB; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return realtimeDB; });
/* unused harmony export DevicesCollection */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventsCollection; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__plugins_firebase__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_firestore__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase_analytics__ = __webpack_require__(229);
// Conveniently import this file anywhere to use db




__WEBPACK_IMPORTED_MODULE_0__plugins_firebase__["a" /* default */].firestore().settings({
  cacheSizeBytes: __WEBPACK_IMPORTED_MODULE_0__plugins_firebase__["a" /* default */].firestore.CACHE_SIZE_UNLIMITED,
  merge: true
});
// firebase.firestore().enablePersistence().catch((err) => console.log(err))
var limitRefDB = 18;
var sliceNumberDB = 10;
var db = __WEBPACK_IMPORTED_MODULE_0__plugins_firebase__["a" /* default */].firestore();
var postsDB = db.collection('posts');
var notifDB = db.collection('notifications');
var userDB = db.collection('users');
var likesDB = db.collection('likes');
var changesDB = db.collection('changes_list');
var settingsDB = db.collection('Settings');

// Realtime
var realtimeDBRef = __WEBPACK_IMPORTED_MODULE_0__plugins_firebase__["a" /* default */].database();
var realtimeDB = __WEBPACK_IMPORTED_MODULE_0__plugins_firebase__["a" /* default */].database();
var DevicesCollection = realtimeDBRef.ref('/devices/');
var EventsCollection = realtimeDBRef.ref('/events/');
// DevicesCollection.child().remove().then(function () {
//   console.log('Remove succeeded.')
// })
//   .catch(function (error) {
//     console.log('Remove failed: ' + error.message)
//   })
// EventsCollection.remove().then(function () {
//   console.log('Remove succeeded.')
// })
//   .catch(function (error) {
//     console.log('Remove failed: ' + error.message)
//   })
// realtimeDB.ref(`/devices/${DeviceInfo.getUniqueId()}`).set(DeviceInfoJson());
// const batch = firebase.firestore().batch();

/***/ }),

/***/ 222:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_POST_DATA_FROM_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_POSTS_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_POSTS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_NEXT_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MERGE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REFRESH_POSTS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_POSTS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_POST_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_POST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_POSTS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_POST_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_POST_DATA; });
// Actions
var GET_POST_DATA_FROM_REFERENCE = 'GET_POST_DATA_FROM_REFERENCE';
var UPDATE_POSTS_DATES = 'UPDATE_POSTS_DATES';
var RESET_POSTS_ACTION = 'RESET_POSTS_ACTION';
var GET_NEXT_POSTS = 'GET_NEXT_POSTS';
var MERGE_POST = 'MERGE_POST';

// Mutations
var REFRESH_POSTS_PUBLISHED_AT = 'REFRESH_POSTS_PUBLISHED_AT';
var UPDATE_POSTS_PUBLISHED_AT = 'UPDATE_POSTS_PUBLISHED_AT';
var UPDATE_POST_REF = 'UPDATE_POST_REF';
var MERGE_POST_DATA = 'MERGE_POST_DATA';
var DELETE_POST = 'DELETE_POST';
var RESET_POSTS = 'RESET_POSTS';
var ADD_POST_REF = 'ADD_POST_REF';
var SET_POST_DATA = 'SET_POST_DATA';

/***/ }),

/***/ 228:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_firebase_performance__ = __webpack_require__(566);



var firebaseConfig = {
  apiKey: "AIzaSyD9wFeiSaBHEbaihyIYGRIxLiLZBouCiCw",
  authDomain: "chifamilyapp-prod.firebaseapp.com",
  databaseURL: "https://chifamilyapp-prod.firebaseio.com",
  projectId: "chifamilyapp-prod",
  storageBucket: "chifamilyapp-prod.appspot.com",
  messagingSenderId: "977662335736",
  appId: "1:977662335736:web:4b4cc50be50839c9f1b90d",
  measurementId: "G-SQHLXVFQT8",
  persistence: true
};
var app = __WEBPACK_IMPORTED_MODULE_0_firebase__["a" /* default */].initializeApp(firebaseConfig);
// export const perf = firebase.performance(app)
/* harmony default export */ __webpack_exports__["a"] = (app);

/***/ }),

/***/ 230:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GET_SINGLE_POST */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LOAD_SINGLE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return LOAD_SINGLE_POST_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return LOAD_SINGLE_POST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MERGE_SINGLE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_SINGLE_POST_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RESET_SINGLE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EXIST_PUBLICATION_SINGLE_POST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SAVE_SINGLE_POST_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SAVE_SINGLE_POST_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_SINGLE_POST_DATA; });
var GET_SINGLE_POST = 'GET_SINGLE_POST';
var LOAD_SINGLE_POST = 'LOAD_SINGLE_POST';
var LOAD_SINGLE_POST_REF = 'LOAD_SINGLE_POST_REF';
var LOAD_SINGLE_POST_DATA = 'LOAD_SINGLE_POST_DATA';
var MERGE_SINGLE_POST = 'MERGE_SINGLE_POST';
var RESET_SINGLE_POST_ACTION = 'RESET_SINGLE_POST_ACTION';
var RESET_SINGLE_POST = 'RESET_SINGLE_POST';
var EXIST_PUBLICATION_SINGLE_POST = 'EXIST_PUBLICATION_SINGLE_POST';
// Mutations
var SAVE_SINGLE_POST_REF = 'SAVE_SINGLE_POST_REF';
var SAVE_SINGLE_POST_DATA = 'SAVE_SINGLE_POST_DATA';
var MERGE_SINGLE_POST_DATA = 'MERGE_SINGLE_POST_DATA';

/***/ }),

/***/ 231:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_NEXT_AUTHORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_AUTHOR_DATA_FROM_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_AUTHORS_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MERGE_AUTHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_AUTHORS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_AUTHORS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REFRESH_AUTHORS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_AUTHOR_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_AUTHOR_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_AUTHOR_REF; });
/* unused harmony export MERGE_AUTHOR_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_AUTHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_AUTHORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_AUTHOR_POST_DATA; });
// Actions
var GET_NEXT_AUTHORS = 'GET_NEXT_AUTHORS';
var GET_AUTHOR_DATA_FROM_REFERENCE = 'GET_AUTHOR_DATA_FROM_REFERENCE';
var UPDATE_AUTHORS_DATES = 'UPDATE_AUTHORS_DATES';
var MERGE_AUTHOR = 'MERGE_AUTHOR';
var RESET_AUTHORS_ACTION = 'RESET_AUTHORS_ACTION';

// Mutations
var UPDATE_AUTHORS_PUBLISHED_AT = 'UPDATE_AUTHORS_PUBLISHED_AT';
var REFRESH_AUTHORS_PUBLISHED_AT = 'REFRESH_AUTHORS_PUBLISHED_AT';
var ADD_AUTHOR_REF = 'ADD_AUTHOR_REF';
var SET_AUTHOR_DATA = 'SET_AUTHOR_DATA';
var UPDATE_AUTHOR_REF = 'UPDATE_AUTHOR_REF';
var MERGE_AUTHOR_DATA = 'MERGE_AUTHOR_DATA';
var DELETE_AUTHOR = 'DELETE_AUTHOR';
var RESET_AUTHORS = 'RESET_AUTHORS';
var MERGE_AUTHOR_POST_DATA = 'MERGE_AUTHOR_POST_DATA';

/***/ }),

/***/ 241:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_NEXT_LIKES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_LIKE_DATA_FROM_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_LIKES_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MERGE_LIKE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_LIKES_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_LIKES_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REFRESH_LIKES_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_LIKE_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_LIKES_PUBLICATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return UPDATE_LIKE_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_LIKES_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_LIKE_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_LIKE; });
/* unused harmony export DELETE_LIKE_REF */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_LIKES; });
// Actions
var GET_NEXT_LIKES = 'GET_NEXT_LIKES';
var GET_LIKE_DATA_FROM_REFERENCE = 'GET_LIKE_DATA_FROM_REFERENCE';
var UPDATE_LIKES_DATES = 'UPDATE_LIKES_DATES';
var MERGE_LIKE = 'MERGE_LIKE';
var RESET_LIKES_ACTION = 'RESET_LIKES_ACTION';

// Mutations
var UPDATE_LIKES_PUBLISHED_AT = 'UPDATE_LIKES_PUBLISHED_AT';
var REFRESH_LIKES_PUBLISHED_AT = 'REFRESH_LIKES_PUBLISHED_AT';
var ADD_LIKE_REF = 'ADD_LIKE_REF';
var SET_LIKES_PUBLICATION = 'SET_LIKES_PUBLICATION';
var UPDATE_LIKE_REF = 'UPDATE_LIKE_REF';
var UPDATE_LIKES_DATA = 'UPDATE_LIKES_DATA';
var MERGE_LIKE_DATA = 'MERGE_LIKE_DATA';
var DELETE_LIKE = 'DELETE_LIKE';
var DELETE_LIKE_REF = 'DELETE_LIKE_REF';
var RESET_LIKES = 'RESET_LIKES';

/***/ }),

/***/ 242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomePage',
  components: {},
  data: function data() {
    return {
      mode: 'login', // 'validateCode'
      requestId: '',
      phone: '',
      showError: false,
      errorMessage: ''
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['userProfile', 'firebaseUUID'])),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["AUTH_LOGOUT"]))

});

/***/ }),

/***/ 243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Email",
  props: {
    open_privacy_link: {
      type: Function,
      default: function _default() {}
    },
    open_term_link: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      showError: false,
      errorMessage: "",
      show3: false,
      email: "",
      password: "",
      snackbar: true,
      vertical: false,
      submitted: false,
      nameRules: {
        required: function required(value) {
          return !!value && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || "E-mail no valido";
        },
        min: function min(v) {
          return v && v.length <= 90 || "Máximo 90 caracteres";
        }
      },
      rules: {
        required: function required(value) {
          return !!value || "Required";
        },
        min: function min(v) {
          return v.length >= 8 || "Min 8 caracteres";
        },
        emailMatch: function emailMatch() {
          return "The email and password you entered don't match";
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["AUTH_LOGIN_CREDENTIAL"]), {
    login: function login() {
      var _this = this;

      if (!this.validate()) return 0;
      this.showError = false;
      this.submitted = true;
      this.AUTH_LOGIN_CREDENTIAL({ email: this.email, password: this.password }).then(function () {}).catch(function () {
        _this.errorMessage = "Las credentiales son incorrectas.";
        _this.showError = true;
        _this.submitted = false;
      });
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    reset: function reset() {
      this.$refs.form.reset();
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    }
  })
});

/***/ }),

/***/ 244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chilogin_store_actions_auth__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LoginForm__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_CodeValidationForm__ = __webpack_require__(626);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  components: {
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__components_LoginForm__["a" /* default */],
    CodeValidationForm: __WEBPACK_IMPORTED_MODULE_2__components_CodeValidationForm__["a" /* default */]
  },
  props: {
    open_privacy_link: {
      type: Function,
      default: function _default() {}
    },
    open_term_link: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      mode: "login", // 'validateCode'
      requestId: "",
      phone: "",
      showError: false,
      errorMessage: "",
      snackbar: true,
      vertical: false
    };
  },

  methods: {
    sendPhone: function sendPhone(phone) {
      this.phone = phone;
      this.showError = false;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__chilogin_store_actions_auth__["g" /* AUTH_LOGIN_PHONE */], phone).then(function (_ref) {
        var requestId = _ref.requestId,
            timeLife = _ref.timeLife;

        // this.$router.push({ name: 'CodeLogin', params: { mobileNumber  } })
        this.requestId = requestId;
        this.mode = "codeValidation";
        this.timeLife = timeLife;
      }.bind(this)).catch(function () {
        this.errorMessage = "No se ha podido mandar la solicitud. Porfavor, intentelo en unos minutos";
        this.showError = true;
        this.snackbar = true;
      }.bind(this));
    },
    resendCode: function resendCode() {
      this.sendPhone(this.phone);
    },
    sendValidation: function sendValidation(validationCode) {
      this.showError = false;
      this.$store.dispatch(__WEBPACK_IMPORTED_MODULE_0__chilogin_store_actions_auth__["h" /* AUTH_LOGIN_PHONE_VALIDATE */], {
        requestId: this.requestId,
        phone: this.phone,
        codeValidation: validationCode
      }).catch(function () {
        this.errorMessage = "Lo sentimos, el código es incorrecto, o ha caducado.";
        this.showError = true;
        this.snackbar = true;
        this.$refs.codeValidation.reset();
      }.bind(this));
    },
    showLogin: function showLogin() {
      this.showError = false;
      this.mode = "login";
    }
  }
});

/***/ }),

/***/ 245:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_phone_number_input_dist_vue_phone_number_input_css__ = __webpack_require__(399);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_phone_number_input_dist_vue_phone_number_input_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_phone_number_input_dist_vue_phone_number_input_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoginForm",
  components: { VuePhoneNumberInput: __WEBPACK_IMPORTED_MODULE_0_vue_phone_number_input___default.a },
  props: {
    open_privacy_link: {
      type: Function,
      default: function _default() {}
    },
    open_term_link: {
      type: Function,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      success: true,
      phoneNumber: "",
      phoneRule: [function (v) {
        return !!v || "Mobile required";
      }],
      submitted: false,
      disableButton: !navigator.onLine
    };
  },

  methods: {
    login: function login() {
      var mobileNumber = this.phoneProps.formatInternational;
      this.submitted = true;
      this.$emit("sendLogin", mobileNumber);
    },
    onUpdate: function onUpdate(props) {
      this.phoneProps = props;
    },

    validate: function validate() {
      return this.$refs.form.validate();
    }
  },
  mounted: function mounted() {
    var _this = this;

    window.addEventListener("online", function () {
      _this.disableButton = false;
    });
    window.addEventListener("offline", function () {
      _this.disableButton = true;
    });
  },

  beforeDestroy: function beforeDestroy() {
    window.removeEventListener("online", function () {});
    window.removeEventListener("offline", function () {});
  }
});

/***/ }),

/***/ 246:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CodeInput__ = __webpack_require__(628);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CodeLogin",
  created: function created() {},

  props: {
    mobileNumber: {
      type: String,
      default: function _default() {
        return "";
      }
    }
  },
  data: function data() {
    return {
      success: true,
      nameRules: [function (v) {
        return !!v || "Code is required";
      }]
    };
  },
  mounted: function mounted() {
    this.setFocusInput("0");
  },

  components: {
    CodeInput: __WEBPACK_IMPORTED_MODULE_1__CodeInput__["a" /* default */]
  },
  methods: {
    setFocusInput: function setFocusInput(position) {
      // const currentPos = this.$refs.codeInput.values.filter(hasValue => hasValue).length.toString();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.$refs.codeInput.$el.children[0].children).filter(function (f) {
        return f.attributes['data-id'].value === position;
      })[0].focus();
    },
    back: function back() {
      this.$emit("back");
    },
    onComplete: function onComplete(v) {
      this.$emit("sendValidation", v);
    },

    sendCode: function sendCode() {
      if (!this.validate()) return 0;
      this.success = true;
    },
    resend: function resend() {
      this.$emit("resendCode");
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    reset: function reset() {
      this.$refs.form.reset();
      this.$refs.codeInput.reset();
    },
    resetValidation: function resetValidation() {
      this.$refs.codeInput.reset();
    }
  }
});

/***/ }),

/***/ 247:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var KEY_CODE = {
  backspace: 8,
  tab: 9,
  enter: 13,
  left: 37,
  up: 38,
  right: 39,
  down: 40
};
// import { browserLog } from '@/helper/helper'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "CodeInput",
  props: {
    type: {
      type: String,
      default: "number"
    },
    fields: {
      type: Number,
      default: 6
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    change: Function,
    complete: Function
  },
  data: function data() {
    var fields = this.fields;

    var code = [];
    for (var index = 0; index < fields; index++) {
      code[index] = { pos: index, value: '' };
    }
    return {
      code: code
    };
  },
  created: function created() {
    this.setFocusOn(0);
  },

  methods: {
    setFocusOn: function setFocusOn(index) {
      var ele = this.$refs["codeval-" + index];
      // browserLog('setFocusOn:: '+index);
      return ele && ele[0] && ele[0].focus();
    },
    getCodeOn: function getCodeOn(index) {
      return this.code[index] && this.code[index].value;
    },
    setCodeOn: function setCodeOn(index, value) {
      var _this = this;

      var fields = this.fields;

      var split = value.split("");
      split.forEach(function (item, i) {
        var cursor = index + i;
        if (cursor > -1 && cursor < fields) {
          _this.code[cursor].value = item;
        }
      });
      var cursorPos = Math.min(fields - 1, index + value.length);
      this.setFocusOn(cursorPos);
      this.triggerChange();
    },
    setCharOn: function setCharOn(index, value) {
      var fields = this.fields;

      if (index > -1 && index < fields) {
        this.code[index].value = value;
        this.triggerChange();
      }
    },
    getFullCode: function getFullCode() {
      return this.code.map(function (ele) {
        return ele.value;
      }).join('');
    },
    reset: function reset() {
      var fields = this.fields;

      for (var index = 0; index < fields; index++) {
        this.code[index].value = "";
      }
      this.setFocusOn(0);
      this.triggerChange();
    },
    onPaste: function onPaste(e) {
      var index = parseInt(e.target.dataset.id);
      // const value = e.target.value.match(/\d/g).join('');
      var value = (e.clipboardData || window.clipboardData).getData('Text').match(/\d/g).join('');
      // browserLog('onPaste:: '+index+" - "+value);
      if (value.length > 0) {
        e.preventDefault();
        this.setCodeOn(index, value);
      }
    },
    onChange: function onChange(e) {
      var index = parseInt(e.target.dataset.id);
      var value = e.target.value.match(/\d/g).join('');
      // browserLog('onChange:: '+index+" - "+value);
      if (value.length > 0) {
        e.preventDefault();
        this.setCodeOn(index, value);
      }
    },
    onKeyDown: function onKeyDown(e) {
      var index = parseInt(e.target.dataset.id);
      var prevIndex = index - 1;
      var nextIndex = index + 1;
      switch (e.keyCode) {
        case KEY_CODE.backspace:
          {
            if (this.getCodeOn(index)) {
              this.setCharOn(index, "");
            } else {
              this.setCharOn(prevIndex, "");
              this.setFocusOn(prevIndex);
            }
            break;
          }
        case KEY_CODE.left:
          this.setFocusOn(prevIndex);
          break;
        case KEY_CODE.right:
          this.setFocusOn(nextIndex);
          break;
        case KEY_CODE.tab:
          if (e.shiftKey) {
            this.setFocusOn(prevIndex);
          } else {
            this.setFocusOn(nextIndex);
          }
          break;
        default:
          if (/\d/.test(e.key)) {
            this.setCodeOn(index, e.key);
          }
          break;
      }
      // browserLog('onKeyDown:: '+index+" - "+e.key);
      e.preventDefault();
    },
    triggerChange: function triggerChange() {
      var fields = this.fields;

      var code = this.getFullCode();
      this.$emit("change", code);
      // browserLog('emit-change:: '+code)
      if (!(code.length < fields)) {
        this.$emit("complete", code);
        // browserLog('emit-complete:: '+code)
      }
    }
  }
});

/***/ }),

/***/ 248:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'RecoverPwd',

  data: function data() {
    return {
      showAlert: false,
      typeAlert: 'error',
      notifyMessage: '',
      email: '',
      snackbar: true,
      vertical: false,
      submitted: false,
      nameRules: {
        required: function required(value) {
          return !!value && /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'E-mail must be valid';
        },
        min: function min(v) {
          return v && v.length <= 90 || 'Name must be less than 90 characters';
        }
      }
    };
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])(["AUTH_FORGET_PASSWORD"]), {
    recovery: function recovery() {
      if (!this.validate()) return 0;
      this.showAlert = false;
      this.submitted = true;
      this.AUTH_FORGET_PASSWORD({ email: this.email }).then(function () {
        this.notifyMessage = 'Se ha enviado un email con los pasos a seguir.';
        this.showAlert = true;
        this.typeAlert = 'success';
      }.bind(this)).catch(function () {
        this.notifyMessage = 'Las credentiales son incorrectas.';
        this.showAlert = true;
        this.typeAlert = 'error';
        this.submitted = false;
      }.bind(this));
    },
    validate: function validate() {
      return this.$refs.form.validate();
    },
    reset: function reset() {
      this.$refs.form.reset();
    },
    resetValidation: function resetValidation() {
      this.$refs.form.resetValidation();
    }
  })

});

/***/ }),

/***/ 31:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export capitalize */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return parseText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return secParseJSON; });
/* unused harmony export removeByKey */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return secureShareLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return titleize; });
/* unused harmony export SortByDateField */
/* unused harmony export comparePublishedAt */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return getValidStyle; });
/* unused harmony export isMobile */
/* unused harmony export browserLog */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return daysFrom; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return forceSSL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return convertEmToPixels; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return likeAtScoreStructure; });
/* unused harmony export sortedIndex */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getIndexForNewItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getIndexForItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addListItem; });
/* unused harmony export updateIndex */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sentry_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);








var capitalize = function capitalize(field) {
  return field.charAt(0).toUpperCase() + field.slice(1);
};

var parseText = function parseText(text) {
  var parsed = secParseJSON(text) || '';
  parsed = unescape(parsed);
  return parsed;
};

var secParseJSON = function secParseJSON(text) {
  var parsed = void 0;
  try {
    parsed = JSON.parse(text);
  } catch (error) {
    parsed = null;
    __WEBPACK_IMPORTED_MODULE_3__sentry_vue__["a" /* captureException */](error);
  }
  return parsed;
};

var removeByKey = function removeByKey(myObj, deleteKey) {
  return Object(__WEBPACK_IMPORTED_MODULE_1_underscore__["b" /* keys */])(myObj).filter(function (key) {
    return key !== deleteKey;
  }).reduce(function (result, current) {
    result[current] = myObj[current];
    return result;
  }, {});
};

var secureShareLink = function secureShareLink(url, createdData, postId, owner) {
  var dateCreated = createdData.seconds;
  var parsePostIDAndCreateDate = btoa(dateCreated + ':' + postId + ':');
  var result = url + '/' + parsePostIDAndCreateDate;
  return result;
};

var _titleizeWord = function _titleizeWord(string) {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
};

var titleize = function titleize(sentence) {
  if (!sentence.split) {
    return _titleizeWord(sentence);
  }
  var result = [];
  sentence.split('_').forEach(function (w) {
    result.push(_titleizeWord(w));
  });
  return result.join('');
};

var SortByDateField = function SortByDateField(arrayOfObjects, field) {
  var orderByDate = arrayOfObjects.sort(function (a, b) {
    return b[field].seconds - a[field].seconds;
  });
  return orderByDate;
};
var comparePublishedAt = function comparePublishedAt(a, b) {
  if (a.published_at < b.published_at) {
    return -1;
  }
  if (a.published_at > b.published_at) {
    return 1;
  }
  return 0;
};

var getValidStyle = function getValidStyle(style) {
  var colors = ['primary', 'secondary', 'success', 'teal', 'danger', 'warning', 'info', 'light', 'dark'];
  return colors.includes(style) ? style : 'primary';
};

var isMobile = function isMobile() {
  return !!navigator.userAgent.toLowerCase().match(/mobile/i);
};

var browserLog = function browserLog(message) {
  __WEBPACK_IMPORTED_MODULE_2__utils_ReactNative__["b" /* isApp */] ? Object(__WEBPACK_IMPORTED_MODULE_2__utils_ReactNative__["d" /* reactNativeLog */])(message) : console.log(message);
};

var daysFrom = function daysFrom(date) {
  var date1 = new Date(date);
  var date2 = new Date();
  var oneDay = 1000 * 60 * 60 * 24;
  var diffInTime = date2.getTime() - (date1.getTime() || 0);
  var diffInDays = Math.round(diffInTime / oneDay);
  return diffInDays;
};

var forceSSL = function forceSSL(initialUrl) {
  return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getForceSSL ? initialUrl.replace('http://', 'https://') : initialUrl;
};

var convertEmToPixels = function convertEmToPixels(pixels) {
  var em = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getFontSizeDeviceInfo;
  return em * pixels;
};
var likeAtScoreStructure = function likeAtScoreStructure(fullScore) {
  var scoreString = fullScore.toString();
  var last4Scoredigits = scoreString.substring(scoreString.length - 4, scoreString.length);
  var formatDate = __WEBPACK_IMPORTED_MODULE_6_moment___default()().format('YYMMDDHHmmss');
  var fullScoreStructure = '' + formatDate + last4Scoredigits;
  return parseInt(fullScoreStructure);
};
var sortedIndex = function sortedIndex(list, fieldName, fieldValue) {
  var low = 0;
  var ele = null;
  var high = list.length;
  var mid = 0;
  while (low < high) {
    mid = Math.floor((low + high) / 2);
    while (!list[mid] || !list[mid][fieldName]) {
      mid += 1;
    }
    ele = list[mid];
    if (fieldValue > ele[fieldName]) high = mid;else low = mid + 1;
  }
  return low;
};
var getIndexForNewItem = function getIndexForNewItem(list, fieldName, fieldValue) {
  // const index = _.findIndex(list, elem => elem && elem[fieldName] <= fieldValue)
  // return index > -1 ? index : list.length
  return sortedIndex(list, fieldName, fieldValue);
};

var getIndexForItem = function getIndexForItem(list, fieldName, fieldValue) {
  return __WEBPACK_IMPORTED_MODULE_5_vue_underscore__["a" /* _ */].findIndex(list, function (elem) {
    return elem && elem[fieldName] === fieldValue;
  });
};

var addListItem = function addListItem(list, newItem, pos) {
  if (pos > list.length) {
    list[pos] = newItem;
    list = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(list));
  } else {
    list.splice(pos, 0, newItem);
  }
  return list;
};

var updateIndex = function updateIndex(list) {
  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : -1;

  to = to < 0 ? list.length : to;
  to = to > list.length ? list.length : to;
  for (var i = from; i < to; i++) {
    if (list[i]) {
      list[i].index = from;
    }
  }
  return list;
};

/***/ }),

/***/ 37:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isApp; });
/* unused harmony export postAppMessage */
/* unused harmony export postAppAction */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shareLink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return openLink; });
/* unused harmony export openLinkExternal */
/* unused harmony export openLinkInternal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return updateBadge; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return configPushNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return reactNativeLog; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sentry_vue__ = __webpack_require__(39);


// import {browserLog} from '@/helper/helper'

var isApp = !!window.ReactNativeWebView;

var postAppMessage = function postAppMessage(message) {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(message);
  } else {
    // browserLog('App environment required: "' + message + '"')
    __WEBPACK_IMPORTED_MODULE_1__sentry_vue__["b" /* captureMessage */]('postAppMessage without app env: "' + message + '"');
  }
};

var postAppAction = function postAppAction(name) {
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  postAppMessage(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
    type: 'WebViewMessage',
    action: name,
    params: params
  }));
};

var shareLink = function shareLink(shareData) {
  postAppAction('shareLink', shareData);
};

var openLink = function openLink(link) {
  isApp ? openLinkExternal(link) : openLinkInternal(link);
};

var openLinkExternal = function openLinkExternal(link) {
  postAppAction('openLink', link);
};

var openLinkInternal = function openLinkInternal(link) {
  link.uri && window.open(link.uri);
};

var updateBadge = function updateBadge(badge) {
  postAppAction('updateBadge', badge);
};

var configPushNotifications = function configPushNotifications() {
  postAppAction('configPushNotifications');
};

var reactNativeLog = function reactNativeLog(msg) {
  postAppAction('log', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({ msg: msg }));
};

/***/ }),

/***/ 384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_vue__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'page404',
  methods: {
    goHome: function goHome() {
      this.$router.push({ name: 'Homepage' }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0__sentry_vue__["a" /* captureException */](error);
      });
    }
  }
});

/***/ }),

/***/ 385:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'MainFooter',
  props: {
    isHomeNavActive: Boolean,
    isNotificationNavActive: Boolean,
    isProfileNavActive: Boolean,
    clickEventHome: Function,
    clickEventNotifications: Function,
    clickEventProfile: Function
  },
  data: function data() {
    return {
      value: 'home'
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getBadgeNotif']), {
    badge: function badge() {
      return this.getBadgeNotif;
    }
  })
});

/***/ }),

/***/ 386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {},
  data: function data() {
    return {
      newVersion: false
    };
  },
  computed: {
    showModal: function showModal() {
      return this.newVersion || this.$store.state.system.newVersion;
    }
  },
  methods: {
    refresh: function refresh() {
      if ('caches' in window) {
        // Service worker cache should be cleared with caches.delete()
        caches.keys().then(function (names) {
          names.forEach(function (name) {
            return caches.delete(name);
          });
        });
      }
      window.location.reload();
    }
  },
  created: function created() {}
});

/***/ }),

/***/ 387:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__sentry_vue__ = __webpack_require__(39);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ConnectingLoader',
  methods: {
    goHome: function goHome() {
      this.$router.push({ name: 'Homepage' }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_0__sentry_vue__["a" /* captureException */](error);
      });
    }
  }
});

/***/ }),

/***/ 388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_underscore__ = __webpack_require__(12);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var profileFields = {
  name: null,
  email: null,
  has_children: true,
  children_birthdate: [{
    value: ''
  }]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OnBoarding',
  created: function created() {
    this.callProfileAction();
  },

  data: function data() {
    var initialized = {
      modalBirthdate: false,
      activePicker: null,
      valid: true,
      loading: true,
      saving: null,
      children_placeholder_texts: ['primer hijo', 'segundo hijo', 'tercer hijo', 'cuarto hijo', 'quinto hijo', 'sexto hijo', 'séptimo hijo', 'octavo hijo'],
      rules: [function (value) {
        return value && value.length >= 3 || 'Min 3 characters';
      }],
      emailRules: [function (v) {
        return (/.+@.+\..+/.test(v) || 'E-mail debe ser válido'
        );
      }],
      rulesRequired: [function (v) {
        return !!v || 'Required';
      }]
    };
    for (var fieldKey in profileFields) {
      initialized[fieldKey] = profileFields[fieldKey];
    }
    return initialized;
  },
  watch: {
    children_birthdate: {
      handler: function handler(item) {
        item.activePicker = 'YEAR';
      },

      deep: true
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["c" /* mapGetters */])(['getProfileData']), {
    childrenBirthdateLength: function childrenBirthdateLength() {
      return this.children_birthdate.length <= 7;
    },
    styles: function styles() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_2__helper_helper__["b" /* convertEmToPixels */])(16);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    },
    stylesAddOtheChild: function stylesAddOtheChild() {
      var result = Object(__WEBPACK_IMPORTED_MODULE_2__helper_helper__["b" /* convertEmToPixels */])(14);
      return {
        'font-size': result + 'px',
        'line-height': result + 2 + 'px'
      };
    }
  }),
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* mapActions */])({
    profileAction: 'GET_PROFILE',
    saveBoarding: 'ONBOARDING',
    addChangeToQueue: 'ADD_TO_QUEUE'
  }), {
    callProfileAction: function callProfileAction() {
      var _this = this;

      this.profileAction().then(function (profile) {
        profile.children_birthdate = __WEBPACK_IMPORTED_MODULE_3_vue_underscore__["a" /* _ */].isEmpty(profile.children_birthdate) ? [''] : profile.children_birthdate;
        for (var field in profile) {
          _this[field] = __WEBPACK_IMPORTED_MODULE_3_vue_underscore__["a" /* _ */].isArray(profileFields[field]) ? (profile[field] || []).map(function (val) {
            return { value: val };
          }) : profile[field];
        }
        _this.loading = false;
      });
    },
    validate: function validate() {
      var _this2 = this;

      var dataToSend = {};
      for (var fieldKey in profileFields) {
        dataToSend[fieldKey] = __WEBPACK_IMPORTED_MODULE_3_vue_underscore__["a" /* _ */].isArray(this[fieldKey]) ? this[fieldKey].map(function (_ref) {
          var value = _ref.value;
          return value;
        }) : this[fieldKey];
      }
      this.$refs.formOnBoarding.validate() && this.saveBoarding(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, dataToSend, { onboarding: false })).then(function () {
        _this2.addChangeToQueue({
          currentScreen: 'users',
          action: 'onboarding',
          fieldsName: ['name', 'onboarding', 'has_children', 'children_birthdate', 'email', 'disabled_fields']
        });
      });
    },
    add: function add() {
      var value = {
        value: '',
        show: 'false'
      };
      this.children_birthdate.push(value);
    },
    remove: function remove(index) {
      this.children_birthdate.splice(index, 1);
    },
    getDisabledInputs: function getDisabledInputs(name) {
      return __WEBPACK_IMPORTED_MODULE_3_vue_underscore__["a" /* _ */].indexOf(this.getProfileData.disabled_fields, name) > 0;
    }
  })
});

/***/ }),

/***/ 389:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/icon.71ed19e.png";

/***/ }),

/***/ 390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import * as Sentry from '@sentry/vue'


// import { browserLog } from '../helper/helper'
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ActiveConnection',
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['getActiveNav'])),
  props: {
    activeNav: Object
  },
  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapActions */])({
    activeNotifAction: 'ACTIVE_NOTIF_VIEW',
    saveDeviceAction: 'DEVICE_ACTION'
  }), {
    next: function next() {
      var details = {
        action: 'PushNotifPermission',
        params: { pushNotifUpdate: true }
      };
      this.saveDeviceAction(details);
      this.$emit('cancelAlert');
      this.activeNotifAction(true);
    },
    activeNotifications: function activeNotifications() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__["a" /* configPushNotifications */])().then(function () {
        _this.activeNotifAction(false);
      });
    }
  })
});

/***/ }),

/***/ 391:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'HomeNavigation',
  router: __WEBPACK_IMPORTED_MODULE_1__router__["d" /* router */],
  created: function created() {
    // this.mainSite()
  },
  props: {},
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isHomeNavActive']), {
    reloadMainSite: function reloadMainSite() {
      if (this.isHomeNavActive && !this.$router.currentRoute.name) {
        this.mainSite();
      }
    }
  }),
  methods: {
    mainSite: function mainSite() {
      this.$router.currentRoute.name !== 'Homepage' && this.$router.push({ name: 'Homepage' });
    }
  },
  mounted: function mounted() {
    this.$emit('navigatorLoaded');
  }
});

/***/ }),

/***/ 392:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'NotificationsNavigation',
  router: __WEBPACK_IMPORTED_MODULE_1__router__["a" /* NotificationNavRouter */],
  created: function created() {},
  props: {},
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isNotificationNavActive']), {
    reloadMainSite: function reloadMainSite() {
      if (this.isNotificationNavActive && !this.$router.currentRoute.name) {
        this.mainSite();
      }
    }
  }),
  methods: {
    mainSite: function mainSite() {
      this.$router.currentRoute.name !== 'Notifications' && this.$router.push({ name: 'Notifications' });

      // this.$router.push({ name: 'Notifications' })
    }
  },
  mounted: function mounted() {
    this.$emit('navigatorLoaded');
  }
});

/***/ }),

/***/ 393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__router__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);

//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfileNavigation',
  router: __WEBPACK_IMPORTED_MODULE_1__router__["b" /* ProfileNavRouter */],
  created: function created() {
    // this.mainSite()
  },
  props: {},
  data: function data() {
    return {};
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["c" /* mapGetters */])(['isProfileNavActive']), {
    reloadMainSite: function reloadMainSite() {
      if (this.isProfileNavActive && !this.$router.currentRoute.name) {
        this.mainSite();
      }
    }
  }),
  methods: {
    mainSite: function mainSite() {
      this.$router.currentRoute.name !== 'Profile' && this.$router.push({ name: 'Profile' });

      // this.$router.push({ name: 'Profile' })
    }
  },
  mounted: function mounted() {
    this.$emit('navigatorLoaded');
  }
});

/***/ }),

/***/ 396:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 399:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 401:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__plugins_vuetify__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_visibleObserver__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__sentry_tracing__ = __webpack_require__(693);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


// import router from './router'







// if ('serviceWorker' in navigator) {
//   // Use the window load event to keep the page load performant
//   window.addEventListener('load', () => {
//     navigator.serviceWorker
//       .register('../dist/service-worker.js')
//       .then(reg => {
//         // registration worked
//         console.log('Registration succeeded. Scope is ' + reg.scope)
//       })
//       .catch(error => {
//         // registration failed
//         console.log('Registration failed with ' + error)
//       })
//   })
// }

if (true) {
  __WEBPACK_IMPORTED_MODULE_6__sentry_vue__["c" /* init */]({
    Vue: __WEBPACK_IMPORTED_MODULE_0_vue__["default"],
    dsn: "https://e26710e11ae745489785065aa861838f@o526222.ingest.sentry.io/5910740",
    environment: "production",
    integrations: [new __WEBPACK_IMPORTED_MODULE_7__sentry_tracing__["a" /* Integrations */].BrowserTracing({
      // routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', "https://app.chifamilyapp.com", /^\//]
    })],
    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1
  });
}

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  // router,
  store: __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */],
  underscore: __WEBPACK_IMPORTED_MODULE_3_vue_underscore__["b" /* default */],
  ObserveVisibility: __WEBPACK_IMPORTED_MODULE_5__plugins_visibleObserver__["a" /* default */],
  vuetify: __WEBPACK_IMPORTED_MODULE_4__plugins_vuetify__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
  }
}).$mount('#app');

/***/ }),

/***/ 404:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(136);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b6d46f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(686);
function injectStyle (ssrContext) {
  __webpack_require__(405)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b6d46f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 405:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 417:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(142);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f932b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(655);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26f932b1_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 47:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_postsQuery__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_singlePostQuery__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_video__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_authorQuery__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_actionsQueue__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_tagsQuery__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_likesQuery__ = __webpack_require__(594);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_notificationQuery__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_profileQuery__ = __webpack_require__(603);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__modules_shareConnection__ = __webpack_require__(605);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__modules_system__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__modules_favQuery__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__modules_webView__ = __webpack_require__(646);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__chi_x_chi_login_lib_store__ = __webpack_require__(648);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__modules_visibility__ = __webpack_require__(653);



// import createPersistedState from 'vuex-persistedstate'















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vuex__["a" /* default */].Store({
  modules: {
    postsQuery: __WEBPACK_IMPORTED_MODULE_3__modules_postsQuery__["a" /* default */],
    singlePostQuery: __WEBPACK_IMPORTED_MODULE_4__modules_singlePostQuery__["a" /* default */],
    notificationQuery: __WEBPACK_IMPORTED_MODULE_10__modules_notificationQuery__["a" /* default */],
    profileQuery: __WEBPACK_IMPORTED_MODULE_11__modules_profileQuery__["a" /* default */],
    shareQuery: __WEBPACK_IMPORTED_MODULE_12__modules_shareConnection__["a" /* default */],
    authorQuery: __WEBPACK_IMPORTED_MODULE_6__modules_authorQuery__["a" /* default */],
    tagsQuery: __WEBPACK_IMPORTED_MODULE_8__modules_tagsQuery__["a" /* default */],
    likesQuery: __WEBPACK_IMPORTED_MODULE_9__modules_likesQuery__["a" /* default */],
    favQuery: __WEBPACK_IMPORTED_MODULE_14__modules_favQuery__["a" /* default */],
    webView: __WEBPACK_IMPORTED_MODULE_15__modules_webView__["a" /* default */],
    video: __WEBPACK_IMPORTED_MODULE_5__modules_video__["a" /* default */],
    actionsQueue: __WEBPACK_IMPORTED_MODULE_7__modules_actionsQueue__["a" /* default */],
    visibility: __WEBPACK_IMPORTED_MODULE_17__modules_visibility__["a" /* default */],
    auth: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_16__chi_x_chi_login_lib_store__["a" /* default */]),
    system: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_13__modules_system__["a" /* default */])
  },
  // plugins: [createPersistedState()],
  strict: debug
}));

/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RegisterEvent; });
/* unused harmony export RegisterEventAsync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(596);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__plugins_firebase__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase_analytics__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_api__ = __webpack_require__(124);





var _this = this;








var RegisterEvent = function RegisterEvent(nameEvent, setObject) {
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    try {
      var result = RegisterEventAsync(nameEvent, setObject);
      resolve(result);
    } catch (error) {
      reject(error);
    }
  });
};

var RegisterEventAsync = function () {
  var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(nameEvent, setObject) {
    var user, deviceInfo, today, userData, newPostRef;
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            user = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.firebaseUUID();
            deviceInfo = __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].getters.getDeviceInfo();
            today = new Date().toLocaleString();
            userData = {
              device_unique_id: deviceInfo.unique_id ? deviceInfo.unique_id : __WEBPACK_IMPORTED_MODULE_8__utils_ReactNative__["b" /* isApp */] ? 'unknown' : 'desktop',
              user_id: user,
              datetime: today,
              created_at: today,
              updated_at: today
            };
            _context.next = 6;
            return __WEBPACK_IMPORTED_MODULE_5__plugins_firebase__["a" /* default */].analytics().setUserId(user);

          case 6:
            _context.next = 8;
            return __WEBPACK_IMPORTED_MODULE_5__plugins_firebase__["a" /* default */].analytics().logEvent(nameEvent, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userData, setObject, {
              action: nameEvent
            }));

          case 8:
            newPostRef = __WEBPACK_IMPORTED_MODULE_4__firestoreDB__["a" /* EventsCollection */].push();

            newPostRef.set(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, userData, setObject, {
              action: nameEvent
            })).then(function () {
              Object(__WEBPACK_IMPORTED_MODULE_9__utils_api__["a" /* apiCall */])({
                url: '/api/v1.0/firebase/notify-event',
                data: { event_id: newPostRef.key },
                method: 'POST'
              });
            });
            return _context.abrupt('return', 'ok');

          case 11:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function RegisterEventAsync(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/***/ }),

/***/ 539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_paginate__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__converters_postConverter__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_helper__ = __webpack_require__(31);






var _actions, _mutations;









var getDefaultState = function getDefaultState() {
  return {
    postsData: [],
    postsRefs: [],
    currentPost: null,
    lastPostPublishedAt: new Date().getTime() / 1000
  };
};

var state = getDefaultState();

var getters = {
  getPostsData: function getPostsData(state) {
    return __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].compact(state.postsData);
  },
  getPostsRefs: function getPostsRefs(state) {
    return state.postsRefs;
  },
  getLastPostPublishedAt: function getLastPostPublishedAt(state) {
    return state.lastPostPublishedAt;
  },
  getCurrentPost: function getCurrentPost(state) {
    return state.currentPost;
  }
};
var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["c" /* GET_NEXT_POSTS */], function (_ref) {
  var getters = _ref.getters,
      dispatch = _ref.dispatch,
      commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    var last = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].last(getters.getPostsRefs);
    var source = Object(__WEBPACK_IMPORTED_MODULE_9__helper_paginate__["d" /* getUserPostsRefsPage */])(last && last.score);
    source.onSnapshot({ includeMetadataChanges: true }, function (snapshot) {
      snapshot.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var postRef = null;
        switch (docChanged.type) {
          case 'added':
            postRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["a" /* ADD_POST_REF */], postRef);
            dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["d" /* GET_POST_DATA_FROM_REFERENCE */], postRef);
            break;
          case 'modified':
            postRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["m" /* UPDATE_POST_REF */], postRef);
            break;
          case 'removed':
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["b" /* DELETE_POST */], doc.id);
            break;
          default:
            break;
        }
      });
      resolve(true);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["d" /* GET_POST_DATA_FROM_REFERENCE */], function (_ref2, item) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      getters = _ref2.getters;

  __WEBPACK_IMPORTED_MODULE_8__firestoreDB__["e" /* postsDB */].where(__WEBPACK_IMPORTED_MODULE_6_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', item.key).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
    snapshotDoc.docChanges().forEach(function (docChanged) {
      var doc = docChanged.doc;
      var postData = null;
      switch (docChanged.type) {
        case 'added':
          postData = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["a" /* docToPostData */])(doc, item);
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["j" /* SET_POST_DATA */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["k" /* UPDATE_POSTS_DATES */]);
          break;
        case 'modified':
          postData = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["a" /* docToPostData */])(doc, item);
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["j" /* SET_POST_DATA */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["k" /* UPDATE_POSTS_DATES */]);
          break;
        case 'removed':
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["b" /* DELETE_POST */], doc.id);
          break;
        default:
          break;
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["k" /* UPDATE_POSTS_DATES */], function (_ref3) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  var twoDaysInSeconds = 172800;
  var minute = 60;
  var todaySeconds = new Date().getTime() / 1000; // today seconds
  if (todaySeconds - getters.getLastPostPublishedAt > minute) {
    getters.getPostsData.map(function (item, index) {
      if (item) {
        var seconds = item.published_at.seconds;
        var diff = todaySeconds - seconds;
        if (diff <= twoDaysInSeconds) {
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["g" /* REFRESH_POSTS_PUBLISHED_AT */], { item: item, index: index });
        } else return true;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["l" /* UPDATE_POSTS_PUBLISHED_AT */], todaySeconds);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["i" /* RESET_POSTS_ACTION */], function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["h" /* RESET_POSTS */]);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["e" /* MERGE_POST */], function (_ref5, value) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["f" /* MERGE_POST_DATA */], value);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["a" /* ADD_POST_REF */], function (state, elemRef) {
  var newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["f" /* getIndexForNewItem */])(state.postsRefs, 'score', elemRef.score);
  state.postsRefs.splice(newIndexRef, 0, elemRef);
  state.postsData.splice(newIndexRef, 0, null);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["m" /* UPDATE_POST_REF */], function (state, elemRef) {
  var oldIndexRef = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.postsRefs, 'key', elemRef.key);
  var oldElemeRef = state.postsRefs[oldIndexRef];
  var elemData = null;
  var newIndexRef = -1;
  var hasIndexChanged = oldElemeRef.score !== elemRef.score;
  if (hasIndexChanged) {
    newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["f" /* getIndexForNewItem */])(state.postsRefs, 'score', elemRef.score);
    hasIndexChanged = newIndexRef !== oldIndexRef;
  }
  if (hasIndexChanged) {
    state.postsRefs.splice(oldIndexRef, 1);
    var elemDataList = state.postsData.splice(oldIndexRef, 1);
    elemData = elemDataList[0] || null;
    newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef; // Testear
    state.postsRefs = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.postsRefs)), elemRef, newIndexRef);
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    state.postsData = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.postsData)), elemData, newIndexRef);
  } else {
    state.postsRefs[oldIndexRef] = elemRef;
    var postsData = state.postsData;
    elemData = postsData[oldIndexRef];
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    postsData[oldIndexRef] = elemData;
    state.postsData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(postsData));
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["j" /* SET_POST_DATA */], function (state, elemData) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.postsRefs, 'key', elemData.key);
  if (index > -1) {
    var postsData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.postsData));
    postsData[index] = elemData;
    state.postsData = postsData;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["f" /* MERGE_POST_DATA */], function (state, value) {
  var key = value.key,
      data = value.data;

  var indexData = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.postsRefs, 'key', key);
  if (indexData > -1) {
    state.postsData[indexData] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.postsData[indexData], { like: data.like });
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["g" /* REFRESH_POSTS_PUBLISHED_AT */], function (state, _ref6) {
  var item = _ref6.item,
      index = _ref6.index;

  state.postsData[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.postsData[index], { moment: Math.random() });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["l" /* UPDATE_POSTS_PUBLISHED_AT */], function (state, dateTimeSeconds) {
  state.lastPostPublishedAt = dateTimeSeconds;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["b" /* DELETE_POST */], function (state, key) {
  var postIndex = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.postsRefs, 'key', key);
  if (postIndex > -1) {
    state.postsRefs.splice(postIndex, 1);
    state.postsData.splice(postIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_postQueries__["h" /* RESET_POSTS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 568:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__converters_postConverter__ = __webpack_require__(72);





var _actions, _mutations;




// import * as Sentry from '@sentry/vue'



var getDefaultState = function getDefaultState() {
  return {
    singlePostData: {},
    singlePostRef: {}
  };
};

var state = getDefaultState();

var getters = {
  getSinglePostData: function getSinglePostData(state) {
    return state.singlePostData;
  },
  getSinglePostRef: function getSinglePostRef(state) {
    return state.singlePostRef;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["d" /* LOAD_SINGLE_POST_REF */], function (_ref, key) {
  var commit = _ref.commit,
      getters = _ref.getters,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_7__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).collection('publications').where(__WEBPACK_IMPORTED_MODULE_6_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', key).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
      snapshotDoc.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var postRef = Object(__WEBPACK_IMPORTED_MODULE_8__converters_postConverter__["b" /* docToPostRef */])(doc);
        commit(__WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["j" /* SAVE_SINGLE_POST_REF */], postRef);
        resolve(postRef);
      });
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["c" /* LOAD_SINGLE_POST_DATA */], function (_ref2, key) {
  var commit = _ref2.commit,
      getters = _ref2.getters,
      dispatch = _ref2.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_7__firestoreDB__["e" /* postsDB */].where(__WEBPACK_IMPORTED_MODULE_6_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', key).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
      snapshotDoc.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var postData = Object(__WEBPACK_IMPORTED_MODULE_8__converters_postConverter__["a" /* docToPostData */])(doc, {});
        commit(__WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["i" /* SAVE_SINGLE_POST_DATA */], postData);
        resolve(postData);
      });
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["b" /* LOAD_SINGLE_POST */], function (_ref3, keyPost) {
  var dispatch = _ref3.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["d" /* LOAD_SINGLE_POST_REF */], keyPost), dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["c" /* LOAD_SINGLE_POST_DATA */], keyPost)]).then(function () {
      resolve(true);
    }).catch(function (error) {
      reject(error);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["e" /* MERGE_SINGLE_POST */], function (_ref4, value) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["f" /* MERGE_SINGLE_POST_DATA */], value);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["a" /* EXIST_PUBLICATION_SINGLE_POST */], function (_ref5, key) {
  var getters = _ref5.getters;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_7__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).collection('publications').doc(key).get().then(function (doc) {
      return doc.exists ? resolve(true) : resolve(false);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["h" /* RESET_SINGLE_POST_ACTION */], function (_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["g" /* RESET_SINGLE_POST */]);
}), _actions);
var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["j" /* SAVE_SINGLE_POST_REF */], function (state, postRef) {
  state.singlePostRef = postRef;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["i" /* SAVE_SINGLE_POST_DATA */], function (state, postData) {
  state.singlePostData = postData;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["f" /* MERGE_SINGLE_POST_DATA */], function (state, value) {
  var data = value.data;

  if (!__WEBPACK_IMPORTED_MODULE_5_vue_underscore__["a" /* _ */].isEmpty(data)) {
    state.singlePostData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.singlePostData, data);
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_singlePostQueries__["g" /* RESET_SINGLE_POST */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_video__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_underscore__ = __webpack_require__(12);





var _actions, _mutations;




// import { browserLog } from '../../helper/helper'
var getDefaultState = function getDefaultState() {
  return {
    videoActiveId: null,
    videoCollection: [],
    muted: !__WEBPACK_IMPORTED_MODULE_5__utils_ReactNative__["b" /* isApp */],
    scrollDirection: '',
    prevPostIndex: -1
  };
};

var state = getDefaultState();

var getters = {
  getVideoCollection: function getVideoCollection(state) {
    return state.videoCollection;
  },
  getMuted: function getMuted(state) {
    return state.muted;
  },
  getVideoActive: function getVideoActive(state) {
    return state.videoActiveId;
  },
  getDirectionScroll: function getDirectionScroll(state) {
    return state.scrollDirection;
  },
  getPrevPosIndex: function getPrevPosIndex(state) {
    return state.prevPostIndex;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_video__["j" /* UPDATE_VIDEO_ACTIVE */], function (_ref) {
  var commit = _ref.commit,
      state = _ref.state;

  var videoCollectionValues = __WEBPACK_IMPORTED_MODULE_6_vue_underscore__["a" /* _ */].values(state.videoCollection);
  videoCollectionValues = __WEBPACK_IMPORTED_MODULE_6_vue_underscore__["a" /* _ */].filter(videoCollectionValues, function (elem) {
    return !!elem;
  });
  var postID = state.scrollDirection === 'up' || window.scrollY < 10 ? __WEBPACK_IMPORTED_MODULE_6_vue_underscore__["a" /* _ */].first(videoCollectionValues) : __WEBPACK_IMPORTED_MODULE_6_vue_underscore__["a" /* _ */].last(videoCollectionValues);

  if (state.videoActiveId !== postID) {
    commit('SET_VIDEO_ACTIVE', postID);
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_video__["k" /* VIDEO_APPEND */], function (_ref2, _ref3) {
  var commit = _ref2.commit,
      state = _ref2.state,
      dispatch = _ref2.dispatch;
  var id = _ref3.id,
      index = _ref3.index;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var direction = state.prevPostIndex < index ? 'down' : 'up';
    commit(__WEBPACK_IMPORTED_MODULE_4__actions_video__["h" /* SET_SCROLL_DIRECTION */], direction);
    commit(__WEBPACK_IMPORTED_MODULE_4__actions_video__["g" /* SET_PREV_POST_INDEX */], index);
    commit(__WEBPACK_IMPORTED_MODULE_4__actions_video__["a" /* ADD_IN_VIDEO_COLLECTION */], { id: id, index: index });
    dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_video__["j" /* UPDATE_VIDEO_ACTIVE */]);
    resolve(true);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_video__["l" /* VIDEO_REMOVE */], function (_ref4, _ref5) {
  var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
  var id = _ref5.id;

  // return new Promise((resolve, reject) => {
  commit(__WEBPACK_IMPORTED_MODULE_4__actions_video__["c" /* REMOVE_VIDEO_FROM_COLLECTION */], id);
  dispatch(__WEBPACK_IMPORTED_MODULE_4__actions_video__["j" /* UPDATE_VIDEO_ACTIVE */]);

  // resolve(true)
  // })
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_video__["b" /* MUTED_VIDEO */], function (_ref6, status) {
  var commit = _ref6.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    commit(__WEBPACK_IMPORTED_MODULE_4__actions_video__["f" /* SAVE_MUTED_VIDEO */], status);
    resolve(status);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_video__["e" /* RESET_VIDEOS_ACTION */], function (_ref7) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__actions_video__["d" /* RESET_VIDEOS */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["i" /* SET_VIDEO_ACTIVE */], function (state, id) {
  state.videoActiveId = id;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["g" /* SET_PREV_POST_INDEX */], function (state, prevIndex) {
  state.prevPostIndex = prevIndex;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["h" /* SET_SCROLL_DIRECTION */], function (state, scrollDirection) {
  state.scrollDirection = scrollDirection;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["c" /* REMOVE_VIDEO_FROM_COLLECTION */], function (state, id) {
  state.videoCollection = state.videoCollection.map(function (elem) {
    return elem === id ? null : elem;
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["a" /* ADD_IN_VIDEO_COLLECTION */], function (state, _ref8) {
  var id = _ref8.id,
      index = _ref8.index;

  var videosId = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.videoCollection));
  videosId[index] = id;
  state.videoCollection = videosId;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["f" /* SAVE_MUTED_VIDEO */], function (state, status) {
  state.muted = status;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_video__["d" /* RESET_VIDEOS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 57:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return router; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NotificationNavRouter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ProfileNavRouter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__login__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__posts__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notifications__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__profile__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_404__ = __webpack_require__(641);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__store__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics__ = __webpack_require__(50);











__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

function setValidationRoute(routerNav) {
  routerNav.afterEach(function (to, from) {
    if (to.meta && to.meta.topScroll) window.scrollTo(0, to.meta.topScroll);
    setTimeout(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          if (to.meta && to.meta.topScroll) {
            window.scrollTo(0, to.meta.topScroll);
          }
        });
      });
    }, 100);
  });

  routerNav.beforeEach(function (to, from, next) {
    var requiresAuth = to.matched.some(function (x) {
      return x.meta.requiresAuth;
    });
    var requiresGuess = to.matched.some(function (x) {
      return x.meta.requiresGuess;
    });
    var isAuthenticated = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.isAuthenticated();

    if (routerNav.history.stack.length !== 0) {
      routerNav.history.stack[routerNav.history.index].meta.topScroll = window.scrollY;
    }
    if (requiresAuth && !isAuthenticated) {
      next({ name: 'Login' });
    } else if (requiresGuess && isAuthenticated) {
      next({ name: 'Homepage' });
    } else {
      if (requiresAuth && isAuthenticated) {
        // if (store.getters.firebaseUUID() && (to.name === 'Homepage')) {
        //   store.dispatch('CALC_BADGE')
        // }
        if (from.name === 'Login') {
          __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].dispatch('GET_PROFILE_BY_USER', __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.firebaseUUID());
          var isMuted = __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.getMuted ? 'chi_video_mute' : 'chi_video_unmute';
          Object(__WEBPACK_IMPORTED_MODULE_9__analytics__["a" /* RegisterEvent */])('chi_user_login', {
            target_id: __WEBPACK_IMPORTED_MODULE_8__store__["a" /* default */].getters.firebaseUUID(),
            target_type: 'user_id'
          });
          Object(__WEBPACK_IMPORTED_MODULE_9__analytics__["a" /* RegisterEvent */])(isMuted, {
            target_id: 'chi_login',
            target_type: 'global_event'
          });
        }
      }

      window.history.replaceState({}, document.title, to.path);
      next();
    }
  });
}

var routes = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_3__login__["a" /* default */]), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_4__posts__["a" /* default */]), [{ path: '*', component: __WEBPACK_IMPORTED_MODULE_7__views_404__["a" /* default */] }]);

var router = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'abstract',
  base: Object({"NODE_ENV":"production","minimize":true,"VUE_APP_APIKEY":"AIzaSyD9wFeiSaBHEbaihyIYGRIxLiLZBouCiCw","VUE_APP_AUTHDOMAIN":"chifamilyapp-prod.firebaseapp.com","VUE_APP_DATABASEURL":"https://chifamilyapp-prod.firebaseio.com","VUE_APP_PROJECTID":"chifamilyapp-prod","VUE_APP_STORAGEBUCKET":"chifamilyapp-prod.appspot.com","VUE_APP_MESSAGINGSENDERID":"977662335736","VUE_APP_APPID":"1:977662335736:web:4b4cc50be50839c9f1b90d","VUE_APP_MEASUREMENTID":"G-SQHLXVFQT8","VUE_APP_API_URL":"https://chi-manager.com","DOMAIN_NAME":"https://app.chifamilyapp.com","SENTRY_DSN":"https://e26710e11ae745489785065aa861838f@o526222.ingest.sentry.io/5910740"}).BASE_URL,
  routes: routes
});

var NotificationNavRouter = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'abstract',
  base: Object({"NODE_ENV":"production","minimize":true,"VUE_APP_APIKEY":"AIzaSyD9wFeiSaBHEbaihyIYGRIxLiLZBouCiCw","VUE_APP_AUTHDOMAIN":"chifamilyapp-prod.firebaseapp.com","VUE_APP_DATABASEURL":"https://chifamilyapp-prod.firebaseio.com","VUE_APP_PROJECTID":"chifamilyapp-prod","VUE_APP_STORAGEBUCKET":"chifamilyapp-prod.appspot.com","VUE_APP_MESSAGINGSENDERID":"977662335736","VUE_APP_APPID":"1:977662335736:web:4b4cc50be50839c9f1b90d","VUE_APP_MEASUREMENTID":"G-SQHLXVFQT8","VUE_APP_API_URL":"https://chi-manager.com","DOMAIN_NAME":"https://app.chifamilyapp.com","SENTRY_DSN":"https://e26710e11ae745489785065aa861838f@o526222.ingest.sentry.io/5910740"}).BASE_URL,
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* default */]), [{ path: '*', component: __WEBPACK_IMPORTED_MODULE_7__views_404__["a" /* default */] }])
});

var ProfileNavRouter = new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  mode: 'abstract',
  base: Object({"NODE_ENV":"production","minimize":true,"VUE_APP_APIKEY":"AIzaSyD9wFeiSaBHEbaihyIYGRIxLiLZBouCiCw","VUE_APP_AUTHDOMAIN":"chifamilyapp-prod.firebaseapp.com","VUE_APP_DATABASEURL":"https://chifamilyapp-prod.firebaseio.com","VUE_APP_PROJECTID":"chifamilyapp-prod","VUE_APP_STORAGEBUCKET":"chifamilyapp-prod.appspot.com","VUE_APP_MESSAGINGSENDERID":"977662335736","VUE_APP_APPID":"1:977662335736:web:4b4cc50be50839c9f1b90d","VUE_APP_MEASUREMENTID":"G-SQHLXVFQT8","VUE_APP_API_URL":"https://chi-manager.com","DOMAIN_NAME":"https://app.chifamilyapp.com","SENTRY_DSN":"https://e26710e11ae745489785065aa861838f@o526222.ingest.sentry.io/5910740"}).BASE_URL,
  routes: [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(__WEBPACK_IMPORTED_MODULE_6__profile__["a" /* default */]), [{ path: '*', component: __WEBPACK_IMPORTED_MODULE_7__views_404__["a" /* default */] }])
});

setValidationRoute(router);
setValidationRoute(NotificationNavRouter);
setValidationRoute(ProfileNavRouter);

/* harmony default export */ __webpack_exports__["c"] = (router);

/***/ }),

/***/ 570:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MUTED_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return VIDEO_APPEND; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return VIDEO_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_VIDEOS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return UPDATE_VIDEO_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_IN_VIDEO_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_VIDEO_FROM_COLLECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return SET_VIDEO_ACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_MUTED_VIDEO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_VIDEOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SET_PREV_POST_INDEX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return SET_SCROLL_DIRECTION; });
var MUTED_VIDEO = 'MUTED_VIDEO';
var VIDEO_APPEND = 'VIDEO_APPEND';
var VIDEO_REMOVE = 'VIDEO_REMOVE';
var RESET_VIDEOS_ACTION = 'RESET_VIDEOS_ACTION';
var UPDATE_VIDEO_ACTIVE = 'UPDATE_VIDEO_ACTIVE';
var ADD_IN_VIDEO_COLLECTION = 'ADD_IN_VIDEO_COLLECTION';
// Mutations
var REMOVE_VIDEO_FROM_COLLECTION = 'REMOVE_VIDEO_FROM_COLLECTION';
var SET_VIDEO_ACTIVE = 'SET_VIDEO_ACTIVE';
var SAVE_MUTED_VIDEO = 'SAVE_MUTED_VIDEO';
var RESET_VIDEOS = 'RESET_VIDEOS';
var SET_PREV_POST_INDEX = 'SET_PREV_POST_INDEX';
var SET_SCROLL_DIRECTION = 'SET_SCROLL_DIRECTION';

/***/ }),

/***/ 571:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__converters_postConverter__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_paginate__ = __webpack_require__(71);






var _actions, _mutations;








var getDefaultState = function getDefaultState() {
  return {
    authorRefs: [],
    authorData: [],
    lastAuthorPublishedAt: new Date().getTime() / 1000
  };
};

var state = getDefaultState();

var getters = {

  getAuthorPostsData: function getAuthorPostsData(state) {
    return __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].compact(state.authorData);
  },
  getAuthorPostsRefs: function getAuthorPostsRefs(state) {
    return state.authorRefs;
  },
  getLastAuthorPostsPublishedAt: function getLastAuthorPostsPublishedAt(state) {
    return state.lastAuthorPublishedAt;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["d" /* GET_NEXT_AUTHORS */], function (_ref, author) {
  var getters = _ref.getters,
      dispatch = _ref.dispatch,
      commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    var last = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].last(getters.getAuthorPostsRefs);
    var source = Object(__WEBPACK_IMPORTED_MODULE_11__helper_paginate__["a" /* getUserAuthorPostsRefsPage */])(last && last.score, author);
    source.onSnapshot({ includeMetadataChanges: true }, function (snapshot) {
      snapshot.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var authorPostRef = null;
        switch (docChanged.type) {
          case 'added':
            authorPostRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["a" /* ADD_AUTHOR_REF */], authorPostRef);
            dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["c" /* GET_AUTHOR_DATA_FROM_REFERENCE */], authorPostRef);
            break;
          case 'modified':
            authorPostRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["m" /* UPDATE_AUTHOR_REF */], authorPostRef);
            break;
          case 'removed':
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["b" /* DELETE_AUTHOR */], doc.id);
            break;
          default:
            break;
        }
      });
      resolve(true);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["c" /* GET_AUTHOR_DATA_FROM_REFERENCE */], function (_ref2, item) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      getters = _ref2.getters;

  __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["e" /* postsDB */].where(__WEBPACK_IMPORTED_MODULE_8_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', item.key).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
    snapshotDoc.docChanges().forEach(function (docChanged) {
      var doc = docChanged.doc;
      var postData = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["a" /* docToPostData */])(doc, item);
      switch (docChanged.type) {
        case 'added':
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["j" /* SET_AUTHOR_DATA */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["k" /* UPDATE_AUTHORS_DATES */]);
          break;
        case 'modified':
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["j" /* SET_AUTHOR_DATA */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["k" /* UPDATE_AUTHORS_DATES */]);
          break;
        case 'removed':
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["b" /* DELETE_AUTHOR */], doc.id);
          break;
        default:
          break;
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["k" /* UPDATE_AUTHORS_DATES */], function (_ref3) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  var twoDaysInSeconds = 172800;
  var minute = 60;
  var todaySeconds = new Date().getTime() / 1000; // today seconds
  if (todaySeconds - getters.getLastAuthorPostsPublishedAt > minute) {
    getters.getAuthorPostsData.map(function (item, index) {
      if (item) {
        var seconds = item.published_at.seconds;
        var diff = todaySeconds - seconds;
        if (diff <= twoDaysInSeconds) {
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["g" /* REFRESH_AUTHORS_PUBLISHED_AT */], { item: item, index: index });
        } else return true;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["l" /* UPDATE_AUTHORS_PUBLISHED_AT */], todaySeconds);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["i" /* RESET_AUTHORS_ACTION */], function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["h" /* RESET_AUTHORS */]);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["e" /* MERGE_AUTHOR */], function (_ref5, value) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["f" /* MERGE_AUTHOR_POST_DATA */], value);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["a" /* ADD_AUTHOR_REF */], function (state, elemRef) {
  var newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["f" /* getIndexForNewItem */])(state.authorRefs, 'score', elemRef.score);
  state.authorRefs.splice(newIndexRef, 0, elemRef);
  state.authorData.splice(newIndexRef, 0, null);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["m" /* UPDATE_AUTHOR_REF */], function (state, elemRef) {
  var oldIndexRef = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["e" /* getIndexForItem */])(state.authorRefs, 'key', elemRef.key);
  var oldElemeRef = state.authorRefs[oldIndexRef];
  var elemData = null;
  var newIndexRef = -1;
  var hasIndexChanged = oldElemeRef.score !== elemRef.score;
  if (hasIndexChanged) {
    newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["f" /* getIndexForNewItem */])(state.authorRefs, 'score', elemRef.score);
    hasIndexChanged = newIndexRef !== oldIndexRef;
  }
  if (hasIndexChanged) {
    state.authorRefs.splice(oldIndexRef, 1);
    var elemDataList = state.authorData.splice(oldIndexRef, 1);
    elemData = elemDataList[0] || null;
    newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef; // Testear
    state.authorRefs = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.authorRefs)), elemRef, newIndexRef);
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    state.authorData = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.authorData)), elemData, newIndexRef);
  } else {
    state.authorRefs[oldIndexRef] = elemRef;
    var authorData = state.authorData;
    elemData = authorData[oldIndexRef];
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    authorData[oldIndexRef] = elemData;
    state.authorData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(authorData));
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["j" /* SET_AUTHOR_DATA */], function (state, elemData) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["e" /* getIndexForItem */])(state.authorRefs, 'key', elemData.key);
  if (index > -1) {
    var authorData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.authorData));
    authorData[index] = elemData;
    state.authorData = authorData;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["f" /* MERGE_AUTHOR_POST_DATA */], function (state, value) {
  var key = value.key,
      data = value.data;

  var postElement = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].findWhere(state.authorData, { key: key });
  if (__WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].size(postElement) > 0) {
    postElement.like = data.like;
    state.authorData[postElement.index] = postElement;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["g" /* REFRESH_AUTHORS_PUBLISHED_AT */], function (state, _ref6) {
  var item = _ref6.item,
      index = _ref6.index;

  state.authorData[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.authorData[index], {
    published_at: item.published_at,
    moment: Math.random()
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["l" /* UPDATE_AUTHORS_PUBLISHED_AT */], function (state, dateTimeSeconds) {
  state.lastFavPublishedAt = dateTimeSeconds;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["b" /* DELETE_AUTHOR */], function (state, key) {
  var postIndex = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["e" /* getIndexForItem */])(state.authorRefs, 'key', key);
  if (postIndex > -1) {
    state.authorRefs.splice(postIndex, 1);
    state.authorData.splice(postIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_authorQueries__["h" /* RESET_AUTHORS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 572:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_actionsQueue__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_api__ = __webpack_require__(124);





// import * as Sentry from '@sentry/vue'
// import { _ } from 'vue-underscore'


var getDefaultState = function getDefaultState() {
  return {
    queue: {}
  };
};

var state = getDefaultState();

var getters = {
  getQueue: function getQueue(state) {
    return state.queue;
  }
};

var actions = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__actions_actionsQueue__["a" /* ADD_TO_QUEUE */], function (_ref, values) {
  var commit = _ref.commit,
      state = _ref.state,
      getters = _ref.getters,
      dispatch = _ref.dispatch;

  return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var _values$key = values.key,
        key = _values$key === undefined ? '' : _values$key,
        _values$fieldsName = values.fieldsName,
        fieldsName = _values$fieldsName === undefined ? [] : _values$fieldsName,
        _values$action = values.action,
        action = _values$action === undefined ? 'updated' : _values$action,
        _values$currentScreen = values.currentScreen,
        currentScreen = _values$currentScreen === undefined ? 'publications' : _values$currentScreen;

    var totalPath = currentScreen === 'users' ? 'users:' + getters.firebaseUUID() : 'users:' + getters.firebaseUUID() + ':' + currentScreen + ':' + key;
    var nowDate = __WEBPACK_IMPORTED_MODULE_5_firebase__["a" /* default */].firestore.Timestamp.fromDate(new Date());
    var setValues = {
      fields: fieldsName,
      action: action,
      updated_at: nowDate
    };
    __WEBPACK_IMPORTED_MODULE_4__firestoreDB__["b" /* changesDB */].doc(totalPath).get().then(function (doc) {
      if (doc.exists) {
        __WEBPACK_IMPORTED_MODULE_4__firestoreDB__["b" /* changesDB */].doc(totalPath).update(setValues).then(function (result) {
          commit(__WEBPACK_IMPORTED_MODULE_3__actions_actionsQueue__["b" /* SAVE_QUEUE */], setValues);
        });
      } else {
        __WEBPACK_IMPORTED_MODULE_4__firestoreDB__["b" /* changesDB */].doc(totalPath).set(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, setValues, { created_at: nowDate })).then(function (result) {
          commit(__WEBPACK_IMPORTED_MODULE_3__actions_actionsQueue__["b" /* SAVE_QUEUE */], __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, setValues, { created_at: nowDate }));
        });
      }

      Object(__WEBPACK_IMPORTED_MODULE_6__utils_api__["a" /* apiCall */])({
        url: '/api/v1.0/firebase/notify-changes',
        data: { change_id: totalPath },
        method: 'POST'
      });
    });
    resolve(true);
  });
});

var mutations = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_3__actions_actionsQueue__["b" /* SAVE_QUEUE */], function (state, queueData) {
  state.queue = queueData;
});

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 573:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TO_QUEUE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SAVE_QUEUE; });
var ADD_TO_QUEUE = 'ADD_TO_QUEUE';
var SAVE_QUEUE = 'SAVE_QUEUE';

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports = {"name":"axios","version":"0.21.4","description":"Promise based HTTP client for the browser and node.js","main":"index.js","scripts":{"test":"grunt test","start":"node ./sandbox/server.js","build":"NODE_ENV=production grunt build","preversion":"npm test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json","postversion":"git push && git push --tags","examples":"node ./examples/server.js","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","fix":"eslint --fix lib/**/*.js"},"repository":{"type":"git","url":"https://github.com/axios/axios.git"},"keywords":["xhr","http","ajax","promise","node"],"author":"Matt Zabriskie","license":"MIT","bugs":{"url":"https://github.com/axios/axios/issues"},"homepage":"https://axios-http.com","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"jsdelivr":"dist/axios.min.js","unpkg":"dist/axios.min.js","typings":"./index.d.ts","dependencies":{"follow-redirects":"^1.14.0"},"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}]}

/***/ }),

/***/ 592:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__converters_postConverter__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_paginate__ = __webpack_require__(71);






var _actions, _mutations;








var getDefaultState = function getDefaultState() {
  return {
    tagRefs: [],
    tagData: [],
    lastAuthorPublishedAt: new Date().getTime() / 1000
  };
};

var state = getDefaultState();

var getters = {

  getTagPostsData: function getTagPostsData(state) {
    return __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].compact(state.tagData);
  },
  getTagPostsRefs: function getTagPostsRefs(state) {
    return state.tagRefs;
  },
  getLastTagPostsPublishedAt: function getLastTagPostsPublishedAt(state) {
    return state.lastAuthorPublishedAt;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["c" /* GET_NEXT_TAGS */], function (_ref, tagName) {
  var getters = _ref.getters,
      dispatch = _ref.dispatch,
      commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    var last = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].last(getters.getTagPostsRefs);
    var source = Object(__WEBPACK_IMPORTED_MODULE_11__helper_paginate__["e" /* getUserTagNamesRefsPage */])(last && last.score, tagName);
    source.onSnapshot({ includeMetadataChanges: true }, function (snapshot) {
      snapshot.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var tagPostRef = null;
        switch (docChanged.type) {
          case 'added':
            tagPostRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["a" /* ADD_TAG_REF */], tagPostRef);
            dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["d" /* GET_TAG_DATA_FROM_REFERENCE */], tagPostRef);
            break;
          case 'modified':
            tagPostRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["m" /* UPDATE_TAG_REF */], tagPostRef);
            break;
          case 'removed':
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["b" /* DELETE_TAG */], doc.id);
            commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["b" /* DELETE_TAG */], doc.id);
            break;
          default:
            break;
        }
      });
      resolve(true);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["d" /* GET_TAG_DATA_FROM_REFERENCE */], function (_ref2, item) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      getters = _ref2.getters;

  __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["e" /* postsDB */].where(__WEBPACK_IMPORTED_MODULE_8_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', item.docId).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
    snapshotDoc.docChanges().forEach(function (docChanged) {
      var doc = docChanged.doc;
      var postData = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["a" /* docToPostData */])(doc, item);
      switch (docChanged.type) {
        case 'added':
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["j" /* SET_TAG_DATA */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["k" /* UPDATE_TAGS_DATES */]);
          break;
        case 'modified':
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["j" /* SET_TAG_DATA */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["k" /* UPDATE_TAGS_DATES */]);
          break;
        case 'removed':
          break;
        default:
          break;
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["k" /* UPDATE_TAGS_DATES */], function (_ref3) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  var twoDaysInSeconds = 172800;
  var minute = 60;
  var todaySeconds = new Date().getTime() / 1000; // today seconds
  if (todaySeconds - getters.getLastTagPostsPublishedAt > minute) {
    getters.getTagPostsData.map(function (item, index) {
      if (item) {
        var seconds = item.published_at.seconds;
        var diff = todaySeconds - seconds;
        if (diff <= twoDaysInSeconds) {
          commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["g" /* REFRESH_TAGS_PUBLISHED_AT */], { item: item, index: index });
        } else return true;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["l" /* UPDATE_TAGS_PUBLISHED_AT */], todaySeconds);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["i" /* RESET_TAGS_ACTION */], function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["h" /* RESET_TAGS */]);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["e" /* MERGE_TAG */], function (_ref5, value) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["f" /* MERGE_TAG_POST_DATA */], value);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["a" /* ADD_TAG_REF */], function (state, elemRef) {
  var newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["f" /* getIndexForNewItem */])(state.tagRefs, 'score', elemRef.score);
  state.tagRefs.splice(newIndexRef, 0, elemRef);
  state.tagData.splice(newIndexRef, 0, null);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["m" /* UPDATE_TAG_REF */], function (state, elemRef) {
  var oldIndexRef = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["e" /* getIndexForItem */])(state.tagRefs, 'key', elemRef.key);
  var oldElemeRef = state.tagRefs[oldIndexRef];
  var elemData = null;
  var newIndexRef = -1;
  var hasIndexChanged = oldElemeRef.score !== elemRef.score;
  if (hasIndexChanged) {
    newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["f" /* getIndexForNewItem */])(state.tagRefs, 'score', elemRef.score);
    hasIndexChanged = newIndexRef !== oldIndexRef;
  }
  if (hasIndexChanged) {
    state.tagRefs.splice(oldIndexRef, 1);
    var elemDataList = state.tagData.splice(oldIndexRef, 1);
    elemData = elemDataList[0] || null;
    newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef; // Testear
    state.tagRefs = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.tagRefs)), elemRef, newIndexRef);
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    state.tagData = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.tagData)), elemData, newIndexRef);
  } else {
    state.tagRefs[oldIndexRef] = elemRef;
    var tagData = state.tagData;
    elemData = tagData[oldIndexRef];
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    tagData[oldIndexRef] = elemData;
    state.tagData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(tagData));
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["j" /* SET_TAG_DATA */], function (state, elemData) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["e" /* getIndexForItem */])(state.tagRefs, 'key', elemData.key);
  if (index > -1) {
    var tagData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.tagData));
    tagData[index] = elemData;
    state.tagData = tagData;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["f" /* MERGE_TAG_POST_DATA */], function (state, value) {
  var key = value.key,
      data = value.data;

  var postElement = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].findWhere(state.tagData, { key: key });
  if (__WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].size(postElement) > 0) {
    postElement.like = data.like;
    state.tagData[postElement.index] = postElement;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["g" /* REFRESH_TAGS_PUBLISHED_AT */], function (state, _ref6) {
  var item = _ref6.item,
      index = _ref6.index;

  state.tagData[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.tagData[index], {
    published_at: item.published_at,
    moment: Math.random()
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["l" /* UPDATE_TAGS_PUBLISHED_AT */], function (state, dateTimeSeconds) {
  state.lastFavPublishedAt = dateTimeSeconds;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["b" /* DELETE_TAG */], function (state, key) {
  var postIndex = Object(__WEBPACK_IMPORTED_MODULE_9__helper_helper__["e" /* getIndexForItem */])(state.tagRefs, 'key', key);
  if (postIndex > -1) {
    state.tagRefs.splice(postIndex, 1);
    state.tagData.splice(postIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_6__actions_tagsQueries__["h" /* RESET_TAGS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 593:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_NEXT_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_TAG_DATA_FROM_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return UPDATE_TAGS_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return MERGE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_TAGS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return UPDATE_TAGS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return REFRESH_TAGS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_TAG_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return UPDATE_TAG_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SET_TAG_DATA; });
/* unused harmony export MERGE_TAG_DATA */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DELETE_TAG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RESET_TAGS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_TAG_POST_DATA; });
// Actions
var GET_NEXT_TAGS = 'GET_NEXT_TAGS';
var GET_TAG_DATA_FROM_REFERENCE = 'GET_TAG_DATA_FROM_REFERENCE';
var UPDATE_TAGS_DATES = 'UPDATE_TAGS_DATES';
var MERGE_TAG = 'MERGE_TAG';
var RESET_TAGS_ACTION = 'RESET_TAGS_ACTION';

// Mutations
var UPDATE_TAGS_PUBLISHED_AT = 'UPDATE_TAGS_PUBLISHED_AT';
var REFRESH_TAGS_PUBLISHED_AT = 'REFRESH_TAGS_PUBLISHED_AT';
var ADD_TAG_REF = 'ADD_TAG_REF';
var UPDATE_TAG_REF = 'UPDATE_TAG_REF';
var SET_TAG_DATA = 'SET_TAG_DATA';
var MERGE_TAG_DATA = 'MERGE_TAG_DATA';
var DELETE_TAG = 'DELETE_TAG';
var RESET_TAGS = 'RESET_TAGS';
var MERGE_TAG_POST_DATA = 'MERGE_TAG_POST_DATA';

/***/ }),

/***/ 594:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_likesQueries__ = __webpack_require__(595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__analytics__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_postQueries__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_authorQueries__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_favQueries__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_singlePostQueries__ = __webpack_require__(230);



var _actions;










var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_likesQueries__["a" /* LIKE_TOGGLE */], function (_ref, _ref2) {
  var dispatch = _ref.dispatch,
      getters = _ref.getters;
  var keyPost = _ref2.keyPost,
      score = _ref2.score,
      like = _ref2.like,
      screenName = _ref2.screenName;

  return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
    var newLike = !like;
    var likeData = {
      like: newLike,
      like_date: newLike ? __WEBPACK_IMPORTED_MODULE_5_firebase__["a" /* default */].firestore.Timestamp.fromDate(new Date()) : null,
      like_at: newLike ? score : null
    };
    __WEBPACK_IMPORTED_MODULE_3__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).collection('publications').doc(keyPost).update(likeData).then(function (_) {
      // dispatch(MERGE_POST_SOURCE, {
      //   key: keyPost,
      //   data: likeData,
      //   screenName
      // })
      var eventName = newLike ? 'chi_post_like' : 'chi_post_dislike';
      Object(__WEBPACK_IMPORTED_MODULE_4__analytics__["a" /* RegisterEvent */])(eventName, {
        target_id: keyPost,
        target_type: 'post_id'
      });
      resolve(newLike);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_likesQueries__["b" /* MERGE_POST_SOURCE */], function (_ref3, value) {
  var commit = _ref3.commit,
      getters = _ref3.getters,
      dispatch = _ref3.dispatch;
  var key = value.key,
      data = value.data,
      screenName = value.screenName;

  var getterAsociated = {
    Homepage: __WEBPACK_IMPORTED_MODULE_6__actions_postQueries__["e" /* MERGE_POST */],
    Mixed: __WEBPACK_IMPORTED_MODULE_7__actions_authorQueries__["e" /* MERGE_AUTHOR */],
    SinglePostFav: __WEBPACK_IMPORTED_MODULE_9__actions_singlePostQueries__["e" /* MERGE_SINGLE_POST */],
    SinglePostNotif: __WEBPACK_IMPORTED_MODULE_9__actions_singlePostQueries__["e" /* MERGE_SINGLE_POST */],
    SinglePostAuthor: __WEBPACK_IMPORTED_MODULE_9__actions_singlePostQueries__["e" /* MERGE_SINGLE_POST */],
    Favs: __WEBPACK_IMPORTED_MODULE_8__actions_favQueries__["e" /* MERGE_LIKE */]
  };
  var sourceInGetters = getterAsociated[screenName];
  sourceInGetters && dispatch(sourceInGetters, { key: key, data: data });
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_likesQueries__["d" /* RESET_LIKES_ACTION */], function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__actions_likesQueries__["c" /* RESET_LIKES */]);
}), _actions);

/* harmony default export */ __webpack_exports__["a"] = ({
  actions: actions
});

/***/ }),

/***/ 595:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LIKE_TOGGLE; });
/* unused harmony export SET_NEW_LIKE */
/* unused harmony export DELETE_NEW_LIKE */
/* unused harmony export LIKE_UPDATE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_LIKES_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return MERGE_POST_SOURCE; });
/* unused harmony export SAVE_NEW_LIKE */
/* unused harmony export DELETE_LIKE */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_LIKES; });
var LIKE_TOGGLE = 'LIKE_TOGGLE';
var SET_NEW_LIKE = 'SET_NEW_LIKE';
var DELETE_NEW_LIKE = 'DELETE_NEW_LIKE';
var LIKE_UPDATE = 'LIKE_UPDATE';
var RESET_LIKES_ACTION = 'RESET_LIKES_ACTION';
// Mutations
var MERGE_POST_SOURCE = 'MERGE_POST_SOURCE';
var SAVE_NEW_LIKE = 'SAVE_NEW_LIKE';
var DELETE_LIKE = 'DELETE_LIKE';
var RESET_LIKES = 'RESET_LIKES';

/***/ }),

/***/ 600:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__ = __webpack_require__(601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__analytics__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_paginate__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__converters_notifConverter__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__helper_helper__ = __webpack_require__(31);






var _actions, _mutations;











var getDefaultState = function getDefaultState() {
  return {
    notifsData: [],
    notifsRefs: [],
    notifBadge: 0,
    badgeSent: false,
    lastNotifPublishedAt: new Date().getTime() / 1000
  };
};

var state = getDefaultState();

var getters = {
  getNotifsData: function getNotifsData(state) {
    return __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].compact(state.notifsData);
  },
  getNotifsRefs: function getNotifsRefs(state) {
    return state.notifsRefs;
  },
  getLastNotifPublishedAt: function getLastNotifPublishedAt(state) {
    return state.lastNotifPublishedAt;
  },
  getBadgeNotif: function getBadgeNotif(state) {
    return state.notifBadge;
  },
  getCheckedBadge: function getCheckedBadge(state) {
    return state.badgeSent;
  }
};
var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["d" /* GET_NEXT_NOTIFS */], function (_ref) {
  var getters = _ref.getters,
      dispatch = _ref.dispatch,
      commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    var last = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].last(getters.getNotifsRefs);
    var source = Object(__WEBPACK_IMPORTED_MODULE_11__helper_paginate__["c" /* getUserNotifsRefsPage */])(last && last.score);
    source.onSnapshot({ includeMetadataChanges: true }, function (snapshot) {
      snapshot.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var notifRef = null;
        switch (docChanged.type) {
          case 'added':
            notifRef = Object(__WEBPACK_IMPORTED_MODULE_12__converters_notifConverter__["b" /* docToNotifRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["a" /* ADD_NOTIF_REF */], notifRef);
            dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["e" /* GET_NOTIF_DATA_FROM_REFERENCE */], notifRef);
            break;
          case 'modified':
            notifRef = Object(__WEBPACK_IMPORTED_MODULE_12__converters_notifConverter__["b" /* docToNotifRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["r" /* UPDATE_NOTIF_REF */], notifRef);
            break;
          case 'removed':
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["c" /* DELETE_NOTIF */], doc.id);
            break;
          default:
            break;
        }
      });
      resolve(true);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["e" /* GET_NOTIF_DATA_FROM_REFERENCE */], function (_ref2, item) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      getters = _ref2.getters;

  __WEBPACK_IMPORTED_MODULE_9__firestoreDB__["d" /* notifDB */].where(__WEBPACK_IMPORTED_MODULE_6_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', item.key).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
    snapshotDoc.docChanges().forEach(function (docChanged) {
      var doc = docChanged.doc;
      var notifData = null;
      switch (docChanged.type) {
        case 'added':
          notifData = Object(__WEBPACK_IMPORTED_MODULE_12__converters_notifConverter__["a" /* docToNotifData */])(doc, item);
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["m" /* SET_NOTIF_DATA */], notifData);
          dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["p" /* UPDATE_NOTIFS_DATES */]);
          break;
        case 'modified':
          notifData = Object(__WEBPACK_IMPORTED_MODULE_12__converters_notifConverter__["a" /* docToNotifData */])(doc, item);
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["m" /* SET_NOTIF_DATA */], notifData);
          dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["p" /* UPDATE_NOTIFS_DATES */]);
          break;
        case 'removed':
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["c" /* DELETE_NOTIF */], doc.id);
          break;
        default:
          break;
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["p" /* UPDATE_NOTIFS_DATES */], function (_ref3) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  var twoDaysInSeconds = 172800;
  var minute = 60;
  var todaySeconds = new Date().getTime() / 1000; // today seconds
  if (todaySeconds - getters.getLastNotifPublishedAt > minute) {
    getters.getNotifsData.map(function (item, index) {
      if (item) {
        var seconds = item.published_at.seconds;
        var diff = todaySeconds - seconds;
        if (diff <= twoDaysInSeconds) {
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["h" /* REFRESH_NOTIFS_PUBLISHED_AT */], { item: item, index: index });
        } else return true;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["q" /* UPDATE_NOTIFS_PUBLISHED_AT */], todaySeconds);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["b" /* CALC_BADGE */], function (_ref4) {
  var commit = _ref4.commit,
      getters = _ref4.getters;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    __WEBPACK_IMPORTED_MODULE_9__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).collection('notifications').where('read', '==', false).onSnapshot({ includeMetadataChanges: true }, function (snapshot) {
      snapshot.docChanges().forEach(function (docChanged) {
        var badge = getters.getBadgeNotif;
        if (docChanged.type === 'added') commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["k" /* SAVE_BADGE */], ++badge);
        if (docChanged.type === 'removed') commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["k" /* SAVE_BADGE */], --badge);
      });
      resolve(true);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["n" /* SET_NOTIF_READ */], function (_ref5, keyNotif) {
  var commit = _ref5.commit,
      getters = _ref5.getters;
  var key = keyNotif.key;

  Object(__WEBPACK_IMPORTED_MODULE_8__analytics__["a" /* RegisterEvent */])('chi_notification_read', {
    target_id: key,
    target_type: 'notification_id'
  });
  __WEBPACK_IMPORTED_MODULE_9__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).collection('notifications').doc(key).update({ read: true }).then(function () {
    commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["l" /* SAVE_NOTIF_READ */], key);
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["j" /* RESET_NOTIFS_ACTION */], function (_ref6) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["i" /* RESET_NOTIFS */]);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["f" /* MERGE_NOTIF */], function (_ref7, value) {
  var commit = _ref7.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["g" /* MERGE_NOTIF_DATA */], value);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["a" /* ADD_NOTIF_REF */], function (state, elemRef) {
  var newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["f" /* getIndexForNewItem */])(state.notifsRefs, 'score', elemRef.score);
  state.notifsRefs.splice(newIndexRef, 0, elemRef);
  state.notifsData.splice(newIndexRef, 0, null);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["r" /* UPDATE_NOTIF_REF */], function (state, elemRef) {
  var oldIndexRef = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["e" /* getIndexForItem */])(state.notifsRefs, 'key', elemRef.key);
  var oldElemeRef = state.notifsRefs[oldIndexRef];
  var elemData = null;
  var newIndexRef = -1;
  var hasIndexChanged = oldElemeRef.score !== elemRef.score;
  if (hasIndexChanged) {
    newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["f" /* getIndexForNewItem */])(state.notifsRefs, 'score', elemRef.score);
    hasIndexChanged = newIndexRef !== oldIndexRef;
  }
  if (hasIndexChanged) {
    state.notifsRefs.splice(oldIndexRef, 1);
    var elemDataList = state.notifsData.splice(oldIndexRef, 1);
    elemData = elemDataList[0] || null;
    newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef; // Testear
    state.notifsRefs = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.notifsRefs)), elemRef, newIndexRef);
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    state.notifsData = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.notifsData)), elemData, newIndexRef);
  } else {
    state.notifsRefs[oldIndexRef] = elemRef;
    var notifsData = state.notifsData;
    elemData = notifsData[oldIndexRef];
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    notifsData[oldIndexRef] = elemData;
    state.notifsData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(notifsData));
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["m" /* SET_NOTIF_DATA */], function (state, elemData) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["e" /* getIndexForItem */])(state.notifsRefs, 'key', elemData.key);
  if (index > -1) {
    var notifsData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.notifsData));
    notifsData[index] = elemData;
    state.notifsData = notifsData;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["o" /* UPDATE_NOTIFS_DATA */], function (state, value) {
  state.notifsData[value.index] = value;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["k" /* SAVE_BADGE */], function (state, value) {
  state.notifBadge = value;
  state.badgeSent = true;
  __WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__["b" /* isApp */] && Object(__WEBPACK_IMPORTED_MODULE_10__utils_ReactNative__["f" /* updateBadge */])(value);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["g" /* MERGE_NOTIF_DATA */], function (state, value) {
  var key = value.key,
      data = value.data;

  var notifElement = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].findWhere(state.notifsData, { key: key });
  if (__WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].size(notifElement) > 0) {
    notifElement.like = data.like;
    state.notifsData[notifElement.index] = notifElement;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["h" /* REFRESH_NOTIFS_PUBLISHED_AT */], function (state, _ref8) {
  var item = _ref8.item,
      index = _ref8.index;

  state.notifsData[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.notifsData[index], {
    published_at: item.published_at,
    moment: Math.random()
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["q" /* UPDATE_NOTIFS_PUBLISHED_AT */], function (state, dateTimeSeconds) {
  state.lastNotifPublishedAt = dateTimeSeconds;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["l" /* SAVE_NOTIF_READ */], function (state, key) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["e" /* getIndexForItem */])(state.notifsRefs, 'key', key);
  state.notifsRefs[index].read = true;
  state.refNotifications = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.notifsRefs));
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["c" /* DELETE_NOTIF */], function (state, key) {
  var postIndex = Object(__WEBPACK_IMPORTED_MODULE_13__helper_helper__["e" /* getIndexForItem */])(state.notifsRefs, 'key', key);
  if (postIndex > -1) {
    state.notifsRefs.splice(postIndex, 1);
    state.notifsData.splice(postIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_notificationQueries__["i" /* RESET_NOTIFS */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 601:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_NOTIF_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return UPDATE_NOTIF_REF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_NEXT_NOTIFS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_NOTIF_DATA_FROM_REFERENCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SET_NOTIF_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return UPDATE_NOTIFS_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return MERGE_NOTIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return MERGE_NOTIF_DATA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return UPDATE_NOTIFS_DATES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return UPDATE_NOTIFS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return REFRESH_NOTIFS_PUBLISHED_AT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return SET_NOTIF_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SAVE_NOTIF_READ; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return DELETE_NOTIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RESET_NOTIFS_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RESET_NOTIFS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CALC_BADGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SAVE_BADGE; });
var ADD_NOTIF_REF = 'ADD_NOTIF_REF';
var UPDATE_NOTIF_REF = 'UPDATE_NOTIF_REF';
var GET_NEXT_NOTIFS = 'GET_NEXT_NOTIFS';
var GET_NOTIF_DATA_FROM_REFERENCE = 'GET_NOTIF_DATA_FROM_REFERENCE';
var SET_NOTIF_DATA = 'SET_NOTIF_DATA';
var UPDATE_NOTIFS_DATA = 'UPDATE_NOTIFS_DATA';
var MERGE_NOTIF = 'MERGE_NOTIF';
var MERGE_NOTIF_DATA = 'MERGE_NOTIF_DATA';
var UPDATE_NOTIFS_DATES = 'UPDATE_NOTIFS_DATES';
var UPDATE_NOTIFS_PUBLISHED_AT = 'UPDATE_NOTIFS_PUBLISHED_AT';
var REFRESH_NOTIFS_PUBLISHED_AT = 'REFRESH_NOTIFS_PUBLISHED_AT';
var SET_NOTIF_READ = 'SET_NOTIF_READ';
var SAVE_NOTIF_READ = 'SAVE_NOTIF_READ';
var DELETE_NOTIF = 'DELETE_NOTIF';
var RESET_NOTIFS_ACTION = 'RESET_NOTIFS_ACTION';
var RESET_NOTIFS = 'RESET_NOTIFS';
var CALC_BADGE = 'CALC_BADGE';
var SAVE_BADGE = 'SAVE_BADGE';

/***/ }),

/***/ 602:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return docToNotifRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return docToNotifData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


var docToNotifRef = function docToNotifRef(doc) {
  var data = doc.data();
  return {
    key: doc.id,
    read: data.read,
    score: data.score,
    docId: data.notif_ref.id,
    published_at: data.published_at
  };
};

var docToNotifData = function docToNotifData(doc, item) {
  var prevData = doc.data();
  var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(prevData));
  var postKey = prevData.source && prevData.source.post && prevData.source.post.id;
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
    key: doc.id,
    postKey: postKey,
    read: item.read,
    score: item.score,
    published_at: item.published_at
  });
};

/***/ }),

/***/ 603:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__ = __webpack_require__(604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_vue__ = __webpack_require__(39);





var _actions, _mutations;




// import { browserLog } from '../../helper/helper'

var getDefaultState = function getDefaultState() {
  return {
    profile: {
      avatar_uri: __webpack_require__(396),
      name: '',
      surname: '',
      disabled_fields: [],
      email: '',
      phone: '',
      onboarding: false,
      active_notification: true,
      has_children: true,
      children_birthdate: []
    }
  };
};

var state = getDefaultState();

var getters = {
  getProfileData: function getProfileData(state) {
    return state.profile;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["d" /* ONBOARDING */], function (_ref, userUpdates) {
  var commit = _ref.commit,
      getters = _ref.getters;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).update(userUpdates).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["h" /* UPDATE_PROFILE */], userUpdates);
    });
    resolve(true);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["a" /* ACTIVE_NOTIF_VIEW */], function (_ref2, isAcceptNotif) {
  var commit = _ref2.commit,
      getters = _ref2.getters;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).update({ active_notification: isAcceptNotif }).then(function () {
      commit(__WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["h" /* UPDATE_PROFILE */], { active_notification: isAcceptNotif });
    });
    resolve(true);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["c" /* GET_PROFILE_BY_USER */], function (_ref3, userId) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["h" /* userDB */].doc(userId).onSnapshot({ includeMetadataChanges: true }, function (documentSnapshot) {
      if (documentSnapshot.exists) {
        var userData = documentSnapshot.data();
        commit(__WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["g" /* SAVE_PROFILE */], userData);
        resolve(userData);
      }
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_6__sentry_vue__["a" /* captureException */](error.message);
      reject(error.message);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["b" /* GET_PROFILE */], function (_ref4) {
  var commit = _ref4.commit,
      getters = _ref4.getters;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["h" /* userDB */].doc(getters.firebaseUUID()).onSnapshot({ includeMetadataChanges: true }, function (documentSnapshot) {
      if (documentSnapshot.exists) {
        var userData = documentSnapshot.data();
        commit(__WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["g" /* SAVE_PROFILE */], userData);
        resolve(userData);
      }
    }, function (error) {
      __WEBPACK_IMPORTED_MODULE_6__sentry_vue__["a" /* captureException */](error.message);
      reject(error.message);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["f" /* RESET_PROFILE_ACTION */], function (_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["e" /* RESET_PROFILE */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["g" /* SAVE_PROFILE */], function (state, user) {
  state.profile = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.profile, user);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["h" /* UPDATE_PROFILE */], function (state, userChanges) {
  state.profile = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.profile, userChanges);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_profileQueries__["e" /* RESET_PROFILE */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 604:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ONBOARDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACTIVE_NOTIF_VIEW; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_PROFILE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GET_PROFILE_BY_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATE_PROFILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_PROFILE; });
var GET_PROFILE = 'GET_PROFILE';
var ONBOARDING = 'ONBOARDING';
var ACTIVE_NOTIF_VIEW = 'ACTIVE_NOTIF_VIEW';
var RESET_PROFILE_ACTION = 'RESET_PROFILE_ACTION';
var GET_PROFILE_BY_USER = 'GET_PROFILE_BY_USER';

// Mutations
var SAVE_PROFILE = 'SAVE_PROFILE';
var UPDATE_PROFILE = 'UPDATE_PROFILE';
var RESET_PROFILE = 'RESET_PROFILE';

/***/ }),

/***/ 605:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_share__ = __webpack_require__(606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__helper_helper__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ReactNative__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__analytics__ = __webpack_require__(50);




var _actions, _mutations;







var getDefaultState = function getDefaultState() {
  return {
    shareLinkData: {},
    isForceSSL: true
  };
};

var state = getDefaultState();

var getters = {
  getShareData: function getShareData(state) {
    return state.shareLinkData;
  },
  getForceSSL: function getForceSSL(state) {
    return state.isForceSSL;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_share__["b" /* GET_FORCE_SSL */], function (_ref) {
  var commit = _ref.commit,
      getters = _ref.getters;

  getters.isAuthenticated() && __WEBPACK_IMPORTED_MODULE_6__firestoreDB__["g" /* settingsDB */].doc('share').get().then(function (doc) {
    if (doc.exists) {
      commit('SAVE_FORCE_SSL', doc.data().force_ssl);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_share__["a" /* CREATE_SHARE_DOMAIN */], function (_ref2, doc) {
  var commit = _ref2.commit,
      getters = _ref2.getters;
  var post = doc.post,
      share = doc.share;

  var link = '';
  __WEBPACK_IMPORTED_MODULE_6__firestoreDB__["g" /* settingsDB */].doc('share').get().then(function (doc) {
    if (doc.exists) {
      var shareDomain = doc.data().share_domain;
      link = shareDomain !== '' ? Object(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["k" /* secureShareLink */])(shareDomain, post.created_at, post.key, getters.firebaseUUID()) : share.default_url;
    } else link = share.default_url;
    Object(__WEBPACK_IMPORTED_MODULE_7__analytics__["a" /* RegisterEvent */])('chi_post_share_click', {
      target_id: link,
      target_type: 'link'
    });
    var shareData = {
      url: link,
      title: share.author,
      message: Object(__WEBPACK_IMPORTED_MODULE_4__helper_helper__["i" /* parseText */])(share.content),
      subject: 'Compartir link'
    };
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_ReactNative__["e" /* shareLink */])(shareData);
    commit(__WEBPACK_IMPORTED_MODULE_3__actions_share__["f" /* SAVE_SHARE_DOMAIN */], shareData);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_share__["d" /* RESET_SHARES_ACTION */], function (_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__actions_share__["c" /* RESET_SHARES */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_share__["f" /* SAVE_SHARE_DOMAIN */], function (state, shareData) {
  state.shareLinkData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, shareData);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_share__["c" /* RESET_SHARES */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_share__["e" /* SAVE_FORCE_SSL */], function (state, forceSSL) {
  state.isForceSSL = forceSSL;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 606:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CREATE_SHARE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_SHARES_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GET_FORCE_SSL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_SHARE_DOMAIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_SHARES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_FORCE_SSL; });
var CREATE_SHARE_DOMAIN = 'CREATE_SHARE_DOMAIN';
var RESET_SHARES_ACTION = 'RESET_SHARES_ACTION';
var GET_FORCE_SSL = 'GET_FORCE_SSL';

// Mutations
var SAVE_SHARE_DOMAIN = 'SAVE_SHARE_DOMAIN';
var RESET_SHARES = 'RESET_SHARES';
var SAVE_FORCE_SSL = 'SAVE_FORCE_SSL';

/***/ }),

/***/ 607:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_system__ = __webpack_require__(608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(57);



var _actions, _mutations;






var getDefaultState = function getDefaultState() {
  return {
    newVersion: false,
    activeNavigation: 'home',
    documentTitle: undefined
  };
};

var state = getDefaultState();

var getters = {
  isHomeNavActive: function isHomeNavActive(state) {
    return state.activeNavigation === 'home';
  },
  isNotificationNavActive: function isNotificationNavActive(state) {
    return state.activeNavigation === 'notifications';
  },
  isProfileNavActive: function isProfileNavActive(state) {
    return state.activeNavigation === 'profile';
  },
  getActiveNav: function getActiveNav(state) {
    return state.activeNavigation;
  },
  getDocumentTitleName: function getDocumentTitleName(state) {
    return state.documentTitle;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_system__["b" /* NEW_VERSION_DETECTED */], function (_ref, data) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__actions_system__["a" /* CHANGE_VERSION */]);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["a" /* CHANGE_HOME_NAV */], function (_ref2) {
  var commit = _ref2.commit;

  if (__WEBPACK_IMPORTED_MODULE_4__router__["d" /* router */].currentRoute.name) window.history.replaceState({}, document.title, __WEBPACK_IMPORTED_MODULE_4__router__["d" /* router */].currentRoute.path);
  commit(__WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["b" /* CHANGE_NAVIGATION_STATE */], 'home');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["c" /* CHANGE_NOTIFICATIONS_NAV */], function (_ref3) {
  var commit = _ref3.commit;

  if (__WEBPACK_IMPORTED_MODULE_4__router__["a" /* NotificationNavRouter */].currentRoute.name) window.history.replaceState({}, document.title, __WEBPACK_IMPORTED_MODULE_4__router__["a" /* NotificationNavRouter */].currentRoute.path);
  commit(__WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["b" /* CHANGE_NAVIGATION_STATE */], 'notifications');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["d" /* CHANGE_PROFILE_NAV */], function (_ref4) {
  var commit = _ref4.commit;

  if (__WEBPACK_IMPORTED_MODULE_4__router__["b" /* ProfileNavRouter */].currentRoute.name) window.history.replaceState({}, document.title, __WEBPACK_IMPORTED_MODULE_4__router__["b" /* ProfileNavRouter */].currentRoute.path);
  commit(__WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["b" /* CHANGE_NAVIGATION_STATE */], 'profile');
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_system__["d" /* RESET_SYSTEM_ACTION */], function (_ref5) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__actions_system__["c" /* RESET_SYSTEM */]);
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_2__actions_system__["f" /* SET_DOCUMENT_TITLE */], function (_ref6, documentTitle) {
  var commit = _ref6.commit;

  commit(__WEBPACK_IMPORTED_MODULE_2__actions_system__["e" /* SAVE_DOCUMENT_TITLE */], documentTitle);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_system__["a" /* CHANGE_VERSION */], function (state) {
  state.newVersion = true;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_navigationChange__["b" /* CHANGE_NAVIGATION_STATE */], function (state, newState) {
  state.activeNavigation = newState;
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_system__["c" /* RESET_SYSTEM */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_2__actions_system__["e" /* SAVE_DOCUMENT_TITLE */], function (state, titleName) {
  state.documentTitle = titleName;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 608:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return NEW_VERSION_DETECTED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_SYSTEM_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SET_DOCUMENT_TITLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_VERSION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_SYSTEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_DOCUMENT_TITLE; });
var NEW_VERSION_DETECTED = 'NEW_VERSION_DETECTED';
var RESET_SYSTEM_ACTION = 'RESET_SYSTEM_ACTION';
var SET_DOCUMENT_TITLE = 'SET_DOCUMENT_TITLE';
// Mutations
var CHANGE_VERSION = 'CHANGE_VERSION';
var RESET_SYSTEM = 'RESET_SYSTEM';
var SAVE_DOCUMENT_TITLE = 'SAVE_DOCUMENT_TITLE';

/***/ }),

/***/ 609:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHANGE_HOME_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return CHANGE_PROFILE_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CHANGE_NOTIFICATIONS_NAV; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return CHANGE_NAVIGATION_STATE; });
var CHANGE_HOME_NAV = 'CHANGE_HOME_NAV';
var CHANGE_PROFILE_NAV = 'CHANGE_PROFILE_NAV';
var CHANGE_NOTIFICATIONS_NAV = 'CHANGE_NOTIFICATIONS_NAV';
var CHANGE_NAVIGATION_STATE = 'CHANGE_NAVIGATION_STATE';

/***/ }),

/***/ 611:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chi_x_chi_login__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__ = __webpack_require__(37);



var routes = [{
  path: '/login',
  name: 'Login',
  component: __WEBPACK_IMPORTED_MODULE_0__chi_x_chi_login__["b" /* Login */],
  props: {
    open_privacy_link: function open_privacy_link() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__["c" /* openLink */])({
        uri: 'https://www.colegiohispanoingles.com/aviso-legal'
      });
    },
    open_term_link: function open_term_link() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__["c" /* openLink */])({
        uri: 'https://www.colegiohispanoingles.com/politica-de-privacidad'
      });
    }
  },
  meta: { requiresGuess: true }
}, {
  path: '/email',
  name: 'Email',
  component: __WEBPACK_IMPORTED_MODULE_0__chi_x_chi_login__["a" /* EmailLogin */],
  props: {
    open_privacy_link: function open_privacy_link() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__["c" /* openLink */])({
        uri: 'https://www.colegiohispanoingles.com/aviso-legal'
      });
    },
    open_term_link: function open_term_link() {
      return Object(__WEBPACK_IMPORTED_MODULE_1__utils_ReactNative__["c" /* openLink */])({
        uri: 'https://www.colegiohispanoingles.com/politica-de-privacidad'
      });
    }
  },
  meta: { requiresGuess: true }
}, {
  path: '/forgot/password',
  name: 'RecoveryPassword',
  component: __WEBPACK_IMPORTED_MODULE_0__chi_x_chi_login__["c" /* RecoveryPassword */],
  meta: { requiresGuess: true }
}];
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Homepage_vue__ = __webpack_require__(242);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4ff7e092_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Homepage_vue__ = __webpack_require__(614);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Homepage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_4ff7e092_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Homepage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 614:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center align-center loginContainer"},[_c('p',[_vm._v("Name: "+_vm._s(_vm.userProfile().name))]),_vm._v(" "),_c('p',[_vm._v("Phone: "+_vm._s(_vm.userProfile().phone))]),_vm._v(" "),_c('p',[_vm._v("Email: "+_vm._s(_vm.userProfile().email))]),_vm._v(" "),_c('p',[_vm._v("UUID: "+_vm._s(_vm.firebaseUUID()))]),_vm._v(" "),_c('v-btn',{on:{"click":_vm.AUTH_LOGOUT}},[_vm._v("Log out")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 615:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmailLogin_vue__ = __webpack_require__(243);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_235dc7f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmailLogin_vue__ = __webpack_require__(617);
function injectStyle (ssrContext) {
  __webpack_require__(616)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_EmailLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_235dc7f2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_EmailLogin_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 616:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 617:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container loginContainer"},[_c('v-form',{ref:"form",staticClass:"formLogin d-flex flex-column justify-space-between justify-md-center align-center full-height",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_c('v-toolbar',{staticClass:"headerToolbar padless",attrs:{"elevation":"0"}},[_c('a',{staticClass:"go-back d-flex",on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',{attrs:{"color":"#0088E0","x-large":""}},[_vm._v("mdi-chevron-left")]),_vm._v("Back")],1)]),_vm._v(" "),_c('div',{staticClass:"form-inputs-wrapper"},[_c('div',{staticClass:"loginImages d-flex flex-column align-center loginImages"},[_c('v-img',{staticClass:"shrink mb-5",attrs:{"alt":"login Logo","position":"center center","contain":"","src":__webpack_require__(618),"transition":"scale-transition","width":"72"}})],1),_vm._v(" "),_c('p',{staticClass:"text-center"},[_c('b',[_vm._v("Login para invitados")])]),_vm._v(" "),_c('p',{staticClass:"font-weight-light  text-caption text-center lighten-1"},[_vm._v("\n        Si has recibido un email de invitación, asegúrate de aceptarlo antes\n        de intentar entrar\n      ")]),_vm._v(" "),_c('div',{staticClass:"inputs"},[_c('v-text-field',{staticClass:"inputLogin",attrs:{"rules":[_vm.nameRules.required, _vm.nameRules.min],"label":"Tu email de invitado","required":"","persistent-placeholder":"","placeholder":"Introduce tu email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"input-group--focused",attrs:{"append-icon":_vm.show3 ? 'mdi-eye' : 'mdi-eye-off',"rules":[_vm.rules.required, _vm.rules.min],"type":_vm.show3 ? 'text' : 'password',"required":"","persistent-placeholder":"","name":"password","label":"Contraseña","hint":"At least 8 characters","placeholder":"Introducir tú contraseña"},on:{"click:append":function($event){_vm.show3 = !_vm.show3}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}}),_vm._v(" "),_c('p',{staticClass:"font-weight-light text--disabled text-caption lighten-1 pl-2 pr-2"},[_vm._v("\n          Al hacer click en Entrar, indicas que has leido y aceptas los\n          "),_c('v-btn',{attrs:{"plain":"","text":"","id":"termsButton","color":"primary","small":"","depressed":""},on:{"click":_vm.open_privacy_link}},[_vm._v("Términos del servicio")]),_vm._v(" y el\n        "),_c('v-btn',{attrs:{"plain":"","text":"","small":"","color":"primary","id":"termsButton","depressed":""},on:{"click":_vm.open_term_link}},[_vm._v("Aviso de privacidad")])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"form-buttons-wrapper"},[_c('v-btn',{staticClass:"mr-4 main-button",attrs:{"color":"primary","type":"submit","large":"","block":"","loading":_vm.submitted,"disabled":_vm.submitted}},[_vm._v("\n        Aceptar\n      ")]),_vm._v(" "),_c('p',{staticClass:"text-center pt-3"},[_c('router-link',{attrs:{"to":{ name: 'RecoveryPassword' }}},[_c('b',[_vm._v("Recuperar contraseña")])])],1)],1)],1),_vm._v(" "),(_vm.showError)?_c('v-snackbar',{attrs:{"centered":"","vertical":_vm.vertical,"content-class":"text-alert","dark":"","timeout":"5000"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n        Close\n      ")])]}}],null,false,3015037550),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('div',{staticClass:"full-alert-message"},[_c('div',[_c('v-icon',{staticClass:"icon-alert",attrs:{"color":"#fff"}},[_vm._v("mdi-car-brake-alert")])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.errorMessage))])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 618:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/emailIcon.e4d86ea.png";

/***/ }),

/***/ 619:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(244);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3eac048d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(632);
function injectStyle (ssrContext) {
  __webpack_require__(620)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_3eac048d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 620:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 621:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__ = __webpack_require__(245);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_37a55b36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__ = __webpack_require__(623);
function injectStyle (ssrContext) {
  __webpack_require__(622)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_LoginForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_37a55b36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_LoginForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 622:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 623:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login d-flex flex-column align-center"},[_c('div',{staticClass:"d-flex flex-column align-center loginImages"},[_c('v-img',{staticClass:"shrink mr-2 imagenLogin",attrs:{"alt":"login Logo","contain":"","src":__webpack_require__(624),"transition":"scale-transition","width":"100","height":"auto"}}),_vm._v(" "),_c('v-img',{staticClass:"shrink mr-2",attrs:{"alt":"Login text","contain":"","src":__webpack_require__(625),"transition":"scale-transition","width":"240","height":"auto"}})],1),_vm._v(" "),_c('v-form',{ref:"form",staticClass:"formLogin",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.login.apply(null, arguments)}}},[_c('div',{staticClass:"inputs mb-5 pt-5"},[_c('p',{staticClass:"subtitle-2"},[_c('b',[_vm._v("Teléfono móvil")])]),_vm._v(" "),_c('vue-phone-number-input',{staticClass:"phone-input",attrs:{"translations":{
          countrySelectorLabel: 'Prefijo',
          countrySelectorError: 'Escoge un país',
          phoneNumberLabel: 'Número',
          example: 'Ej.'
        },"default-country-code":'ES',"preferred-countries":['ES'],"show-code-on-list":"","required":""},on:{"update":_vm.onUpdate},model:{value:(_vm.phoneNumber),callback:function ($$v) {_vm.phoneNumber=$$v},expression:"phoneNumber"}}),_vm._v(" "),_c('div',{staticClass:"font-weight-light text--disabled text-caption pt-2 ma-0"},[_vm._v("\n        *required\n      ")])],1),_vm._v(" "),_c('div',{},[_c('p',{staticClass:"font-weight-light text--disabled text-caption lighten-1 pl-2 pr-2"},[_vm._v("\n        Al hacer click en Entrar, indicas que has leido y aceptas los\n        "),_c('v-btn',{attrs:{"plain":"","text":"","id":"termsButton","color":"primary","small":"","depressed":""},on:{"click":_vm.open_privacy_link}},[_vm._v("Términos del servicio")]),_vm._v("\n        y el\n        "),_c('v-btn',{attrs:{"plain":"","text":"","small":"","color":"primary","id":"termsButton","depressed":""},on:{"click":_vm.open_term_link}},[_vm._v("Aviso de privacidad")])],1),_vm._v(" "),_c('v-btn',{staticClass:"mr-4 main-button",attrs:{"color":"primary","type":"submit","large":"","block":"","depressed":"","loading":_vm.submitted,"disabled":_vm.disableButton || _vm.submitted}},[_vm._v("\n        Aceptar\n      ")]),_vm._v(" "),(false)?_c('p',{staticClass:"text-center pt-3"},[_c('a',{attrs:{"href":"/email"}},[_c('b',[_vm._v("¿Te llegó una invitación por email?")])])]):_vm._e()],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 624:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logoImage.4e569fc.png";

/***/ }),

/***/ 625:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logoText.3a5bac4.png";

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CodeValidationForm_vue__ = __webpack_require__(246);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1904ff7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CodeValidationForm_vue__ = __webpack_require__(631);
function injectStyle (ssrContext) {
  __webpack_require__(627)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1904ff7a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CodeValidationForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_1904ff7a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CodeValidationForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 627:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 628:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CodeInput_vue__ = __webpack_require__(247);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_67519928_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CodeInput_vue__ = __webpack_require__(630);
function injectStyle (ssrContext) {
  __webpack_require__(629)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-67519928"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_CodeInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_67519928_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_CodeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 629:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 630:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"codeInputWrapper",staticClass:"code-input-wrapper"},[_vm._l((_vm.code),function(code,index){return [_c('input',{key:("key-codeval-" + index),ref:("codeval-" + index),refInFor:true,attrs:{"data-id":index,"type":_vm.type === 'number' ? 'tel' : _vm.type,"pattern":_vm.type === 'number' ? '[0-9]' : null,"autoFocus":index === 0,"disabled":_vm.disabled,"required":_vm.required},domProps:{"value":code.value},on:{"keydown":_vm.onKeyDown,"paste":_vm.onPaste,"input":_vm.onChange}})]})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 631:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"codeContainer"},[_c('v-form',{ref:"form",staticClass:"formLogin d-flex flex-column justify-space-between justify-md-center align-center full-height",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.sendCode.apply(null, arguments)}}},[_c('v-toolbar',{staticClass:"headerToolbar padless",attrs:{"elevation":"0"}},[_c('a',{staticClass:"go-back d-flex",on:{"click":_vm.back}},[_c('v-icon',{attrs:{"color":"#0088E0","x-large":""}},[_vm._v("mdi-chevron-left")]),_vm._v("Back")],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:" subtitle-1 lighten-1"},[_vm._v("\n        Verificar número de teléfono\n      ")])],1),_vm._v(" "),_c('div',{staticClass:"form-inputs-wrapper"},[_c('div',{staticClass:"texts"},[_c('p',{staticClass:"mb-1"},[_c('b',[_vm._v("Escribe tu código de Verificación")])]),_vm._v(" "),(_vm.mobileNumber)?_c('p',[_vm._v("\n          Hemos enviado el código al número de teléfono "),_c('b',[_vm._v(_vm._s(_vm.mobileNumber))])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"inputs pb-10 pt-5"},[_c('code-input',{ref:"codeInput",staticClass:"input inputLogin text-center mb-5",on:{"complete":_vm.onComplete}}),_vm._v(" "),_c('p',{staticClass:"text-caption text-center lighten-1"},[_vm._v("\n          Este código caducará en 5 minutos.\n        ")]),_vm._v(" "),_c('p',{staticClass:"text-caption text-center lighten-1 pr-2 pl-2"},[_vm._v("\n          CHI Family puede usar tu número de teléfono para llamarte o enviarte\n          mensajes de texto con información sobre tu cuenta.\n        ")])],1)]),_vm._v(" "),_c('div',{staticClass:"form-buttons-wrapper"},[(false)?_c('p',{staticClass:"text-center"},[_c('v-btn',{attrs:{"plain":""},on:{"click":_vm.resend}},[_c('b',[_vm._v("Enviar de nuevo el código SMS")])])],1):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 632:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loginContainer main-container"},[(_vm.mode === 'login')?_c('login-form',{attrs:{"open_term_link":_vm.open_term_link,"open_privacy_link":_vm.open_privacy_link},on:{"sendLogin":_vm.sendPhone}}):_c('code-validation-form',{ref:"codeValidation",attrs:{"mobileNumber":_vm.phone},on:{"back":_vm.showLogin,"sendValidation":_vm.sendValidation,"resendCode":_vm.resendCode}}),_vm._v(" "),(_vm.showError)?_c('v-snackbar',{attrs:{"centered":"","vertical":_vm.vertical,"content-class":"text-alert","dark":"","timeout":"5000"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n        Close\n      ")])]}}],null,false,3015037550),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('div',{staticClass:"full-alert-message"},[_c('div',[_c('v-icon',{staticClass:"icon-alert",attrs:{"color":"#fff"}},[_vm._v("mdi-car-brake-alert")])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.errorMessage))])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 633:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RecoveryPassword_vue__ = __webpack_require__(248);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_442539c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RecoveryPassword_vue__ = __webpack_require__(635);
function injectStyle (ssrContext) {
  __webpack_require__(634)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_RecoveryPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_442539c2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_RecoveryPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 634:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 635:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-container loginContainer"},[_c('v-form',{ref:"form",staticClass:"formLogin d-flex flex-column justify-space-between justify-md-center align-center full-height",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.recovery.apply(null, arguments)}}},[_c('v-toolbar',{staticClass:"headerToolbar padless",attrs:{"elevation":"0"}},[_c('a',{staticClass:"go-back d-flex",on:{"click":function($event){return _vm.$router.back()}}},[_c('v-icon',{attrs:{"color":"#0088E0","x-large":""}},[_vm._v("mdi-chevron-left")]),_vm._v("Back")],1)]),_vm._v(" "),_c('div',{staticClass:"form-inputs-wrapper"},[_c('p',{staticClass:"lighten-1"},[_vm._v("\n        Para recuperar tu contraseña, introduce tu email de usuario registrado en el sistema.\n      ")]),_vm._v(" "),_c('p',{staticClass:"lighten-1"},[_vm._v("\n        En caso de error, escríbenos a través de "),_c('a',{attrs:{"href":"https://www.colegiohispanoingles.com/help","target":"_blank"}},[_vm._v("www.colegiohispanoingles.com/help")]),_vm._v(".\n      ")]),_vm._v(" "),_c('div',{staticClass:"inputs"},[_c('v-text-field',{staticClass:"inputLogin",attrs:{"rules":[_vm.nameRules.required, _vm.nameRules.min],"label":"Email de usuario","required":"","persistent-placeholder":"","placeholder":"Introduce tu email"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-buttons-wrapper"},[_c('v-btn',{staticClass:"mr-4 main-button",attrs:{"color":"primary","type":"submit","large":"","block":"","loading":_vm.submitted,"disabled":_vm.submitted}},[_vm._v("\n        Enviar instrucciones\n      ")])],1)],1),_vm._v(" "),(_vm.showAlert)?_c('v-snackbar',{attrs:{"centered":"","vertical":_vm.vertical,"content-class":"text-alert","dark":"","timeout":"5000"},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var attrs = ref.attrs;
return [_c('v-btn',_vm._b({attrs:{"color":"pink","text":""},on:{"click":function($event){_vm.snackbar = false}}},'v-btn',attrs,false),[_vm._v("\n        Close\n      ")])]}}],null,false,3015037550),model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_c('div',{staticClass:"full-alert-message"},[_c('div',[_c('v-icon',{staticClass:"icon-alert",attrs:{"color":"#fff"}},[_vm._v("mdi-car-brake-alert")])],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.notifyMessage))])])]):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 636:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helper_helper__ = __webpack_require__(31);

var routes = [{
  path: '/',
  name: 'Homepage',
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 710));
  },
  meta: { requiresAuth: true, footerIcon: 'home', titleName: function titleName(route) {} }
}, {
  path: '/authors/:name',
  component: function component() {
    return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 134));
  },
  children: [{
    path: '/',
    name: 'Mixed',
    component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 135));
    },
    props: function props(route) {
      return {
        actionProps: {
          mainAction: 'GET_NEXT_AUTHORS',
          resetAction: 'RESET_AUTHORS_ACTION'
        },
        getterProps: ['getAuthorPostsData', 'getAuthorPostsRefs'],
        actionParamsProps: route.params.name
      };
    },
    meta: {
      requiresAuth: true,
      footerIcon: 'home',
      titleName: function titleName(route) {
        return route.params.name;
      }
    }
  }, {
    path: 'posts/:postId',
    name: 'SinglePostAuthor',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 86));
    },
    meta: {
      requiresAuth: true,
      footerIcon: 'home',
      titleName: function titleName(route) {
        return 'Noticia';
      }
    }
  }]
}, {
  path: '/posts/:postId', // postId
  name: 'SinglePost',
  component: function component() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 86));
  },
  meta: {
    requiresAuth: true,
    footerIcon: 'home',
    titleName: function titleName(route) {
      return 'Noticia';
    }
  }
}, {
  path: '/tags/:name',
  name: 'MixedTag',
  component: function component() {
    return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 135));
  },
  props: function props(route) {
    return {
      actionProps: {
        mainAction: 'GET_NEXT_TAGS',
        resetAction: 'RESET_TAGS_ACTION'
      },
      getterProps: ['getTagPostsData', 'getTagPostsRefs'],
      actionParamsProps: route.params.name
    };
  },
  meta: {
    requiresAuth: true,
    footerIcon: 'home',
    titleName: function titleName(route) {
      return '#' + Object(__WEBPACK_IMPORTED_MODULE_0__helper_helper__["l" /* titleize */])(route.params.name);
    }
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 638:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 249,
	"./af.js": 249,
	"./ar": 250,
	"./ar-dz": 251,
	"./ar-dz.js": 251,
	"./ar-kw": 252,
	"./ar-kw.js": 252,
	"./ar-ly": 253,
	"./ar-ly.js": 253,
	"./ar-ma": 254,
	"./ar-ma.js": 254,
	"./ar-sa": 255,
	"./ar-sa.js": 255,
	"./ar-tn": 256,
	"./ar-tn.js": 256,
	"./ar.js": 250,
	"./az": 257,
	"./az.js": 257,
	"./be": 258,
	"./be.js": 258,
	"./bg": 259,
	"./bg.js": 259,
	"./bm": 260,
	"./bm.js": 260,
	"./bn": 261,
	"./bn-bd": 262,
	"./bn-bd.js": 262,
	"./bn.js": 261,
	"./bo": 263,
	"./bo.js": 263,
	"./br": 264,
	"./br.js": 264,
	"./bs": 265,
	"./bs.js": 265,
	"./ca": 266,
	"./ca.js": 266,
	"./cs": 267,
	"./cs.js": 267,
	"./cv": 268,
	"./cv.js": 268,
	"./cy": 269,
	"./cy.js": 269,
	"./da": 270,
	"./da.js": 270,
	"./de": 271,
	"./de-at": 272,
	"./de-at.js": 272,
	"./de-ch": 273,
	"./de-ch.js": 273,
	"./de.js": 271,
	"./dv": 274,
	"./dv.js": 274,
	"./el": 275,
	"./el.js": 275,
	"./en-au": 276,
	"./en-au.js": 276,
	"./en-ca": 277,
	"./en-ca.js": 277,
	"./en-gb": 278,
	"./en-gb.js": 278,
	"./en-ie": 279,
	"./en-ie.js": 279,
	"./en-il": 280,
	"./en-il.js": 280,
	"./en-in": 281,
	"./en-in.js": 281,
	"./en-nz": 282,
	"./en-nz.js": 282,
	"./en-sg": 283,
	"./en-sg.js": 283,
	"./eo": 284,
	"./eo.js": 284,
	"./es": 285,
	"./es-do": 286,
	"./es-do.js": 286,
	"./es-mx": 287,
	"./es-mx.js": 287,
	"./es-us": 288,
	"./es-us.js": 288,
	"./es.js": 285,
	"./et": 289,
	"./et.js": 289,
	"./eu": 290,
	"./eu.js": 290,
	"./fa": 291,
	"./fa.js": 291,
	"./fi": 292,
	"./fi.js": 292,
	"./fil": 293,
	"./fil.js": 293,
	"./fo": 294,
	"./fo.js": 294,
	"./fr": 295,
	"./fr-ca": 296,
	"./fr-ca.js": 296,
	"./fr-ch": 297,
	"./fr-ch.js": 297,
	"./fr.js": 295,
	"./fy": 298,
	"./fy.js": 298,
	"./ga": 299,
	"./ga.js": 299,
	"./gd": 300,
	"./gd.js": 300,
	"./gl": 301,
	"./gl.js": 301,
	"./gom-deva": 302,
	"./gom-deva.js": 302,
	"./gom-latn": 303,
	"./gom-latn.js": 303,
	"./gu": 304,
	"./gu.js": 304,
	"./he": 305,
	"./he.js": 305,
	"./hi": 306,
	"./hi.js": 306,
	"./hr": 307,
	"./hr.js": 307,
	"./hu": 308,
	"./hu.js": 308,
	"./hy-am": 309,
	"./hy-am.js": 309,
	"./id": 310,
	"./id.js": 310,
	"./is": 311,
	"./is.js": 311,
	"./it": 312,
	"./it-ch": 313,
	"./it-ch.js": 313,
	"./it.js": 312,
	"./ja": 314,
	"./ja.js": 314,
	"./jv": 315,
	"./jv.js": 315,
	"./ka": 316,
	"./ka.js": 316,
	"./kk": 317,
	"./kk.js": 317,
	"./km": 318,
	"./km.js": 318,
	"./kn": 319,
	"./kn.js": 319,
	"./ko": 320,
	"./ko.js": 320,
	"./ku": 321,
	"./ku.js": 321,
	"./ky": 322,
	"./ky.js": 322,
	"./lb": 323,
	"./lb.js": 323,
	"./lo": 324,
	"./lo.js": 324,
	"./lt": 325,
	"./lt.js": 325,
	"./lv": 326,
	"./lv.js": 326,
	"./me": 327,
	"./me.js": 327,
	"./mi": 328,
	"./mi.js": 328,
	"./mk": 329,
	"./mk.js": 329,
	"./ml": 330,
	"./ml.js": 330,
	"./mn": 331,
	"./mn.js": 331,
	"./mr": 332,
	"./mr.js": 332,
	"./ms": 333,
	"./ms-my": 334,
	"./ms-my.js": 334,
	"./ms.js": 333,
	"./mt": 335,
	"./mt.js": 335,
	"./my": 336,
	"./my.js": 336,
	"./nb": 337,
	"./nb.js": 337,
	"./ne": 338,
	"./ne.js": 338,
	"./nl": 339,
	"./nl-be": 340,
	"./nl-be.js": 340,
	"./nl.js": 339,
	"./nn": 341,
	"./nn.js": 341,
	"./oc-lnc": 342,
	"./oc-lnc.js": 342,
	"./pa-in": 343,
	"./pa-in.js": 343,
	"./pl": 344,
	"./pl.js": 344,
	"./pt": 345,
	"./pt-br": 346,
	"./pt-br.js": 346,
	"./pt.js": 345,
	"./ro": 347,
	"./ro.js": 347,
	"./ru": 348,
	"./ru.js": 348,
	"./sd": 349,
	"./sd.js": 349,
	"./se": 350,
	"./se.js": 350,
	"./si": 351,
	"./si.js": 351,
	"./sk": 352,
	"./sk.js": 352,
	"./sl": 353,
	"./sl.js": 353,
	"./sq": 354,
	"./sq.js": 354,
	"./sr": 355,
	"./sr-cyrl": 356,
	"./sr-cyrl.js": 356,
	"./sr.js": 355,
	"./ss": 357,
	"./ss.js": 357,
	"./sv": 358,
	"./sv.js": 358,
	"./sw": 359,
	"./sw.js": 359,
	"./ta": 360,
	"./ta.js": 360,
	"./te": 361,
	"./te.js": 361,
	"./tet": 362,
	"./tet.js": 362,
	"./tg": 363,
	"./tg.js": 363,
	"./th": 364,
	"./th.js": 364,
	"./tk": 365,
	"./tk.js": 365,
	"./tl-ph": 366,
	"./tl-ph.js": 366,
	"./tlh": 367,
	"./tlh.js": 367,
	"./tr": 368,
	"./tr.js": 368,
	"./tzl": 369,
	"./tzl.js": 369,
	"./tzm": 370,
	"./tzm-latn": 371,
	"./tzm-latn.js": 371,
	"./tzm.js": 370,
	"./ug-cn": 372,
	"./ug-cn.js": 372,
	"./uk": 373,
	"./uk.js": 373,
	"./ur": 374,
	"./ur.js": 374,
	"./uz": 375,
	"./uz-latn": 376,
	"./uz-latn.js": 376,
	"./uz.js": 375,
	"./vi": 377,
	"./vi.js": 377,
	"./x-pseudo": 378,
	"./x-pseudo.js": 378,
	"./yo": 379,
	"./yo.js": 379,
	"./zh-cn": 380,
	"./zh-cn.js": 380,
	"./zh-hk": 381,
	"./zh-hk.js": 381,
	"./zh-mo": 382,
	"./zh-mo.js": 382,
	"./zh-tw": 383,
	"./zh-tw.js": 383
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 638;

/***/ }),

/***/ 639:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var NotificationNavRoutes = [{
  path: '/notifications',
  component: function component() {
    return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 134));
  },
  children: [{
    path: '/',
    name: 'Notifications',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 711));
    },
    meta: { requiresAuth: true, footerIcon: 'notifications', titleName: function titleName(route) {} }
  }, {
    path: ':notifId/posts/:postId',
    name: 'SinglePostNotif',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 86));
    },
    meta: {
      requiresAuth: true,
      footerIcon: 'notifications',
      titleName: function titleName(route) {
        return 'Noticia';
      }
    }
  }]
}];
/* harmony default export */ __webpack_exports__["a"] = (NotificationNavRoutes);

/***/ }),

/***/ 640:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var ProfileNavRoutes = [{
  path: '/profile',
  name: 'Profile',
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 712));
  },
  meta: { requiresAuth: true, footerIcon: 'profile', titleName: function titleName(route) {} }
}, {
  path: '/favourites',
  component: function component() {
    return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 134));
  },
  children: [{
    path: '/',
    name: 'Favs',
    component: function component() {
      return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 135));
    },
    props: function props(route) {
      return {
        actionProps: {
          mainAction: 'GET_NEXT_LIKES',
          resetAction: 'RESET_LIKES_ACTION'
        },
        getterProps: ['getFavsData', 'getFavsRefs'],
        actionParamsProps: null
      };
    },
    meta: {
      requiresAuth: true,
      footerIcon: 'profile',
      titleName: function titleName(route) {
        return 'Mis favoritos';
      }
    }
  }, {
    path: 'posts/:postId',
    name: 'SinglePostFav',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 86));
    },
    meta: {
      requiresAuth: true,
      footerIcon: 'profile',
      titleName: function titleName(route) {
        return 'Noticia';
      }
    }
  }]
}, {
  path: '/edit-profile',
  name: 'EditProfile',
  component: function component() {
    return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 713));
  },
  meta: {
    requiresAuth: true,
    footerIcon: 'profile',
    titleName: function titleName(route) {
      return 'Editar perfil';
    }
  }
}];
/* harmony default export */ __webpack_exports__["a"] = (ProfileNavRoutes);

/***/ }),

/***/ 641:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__ = __webpack_require__(384);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b7ffd7f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__ = __webpack_require__(643);
function injectStyle (ssrContext) {
  __webpack_require__(642)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_404_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b7ffd7f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 642:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 643:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page404Container"},[_c('div',{staticClass:"message404"},[_c('h1',[_vm._v("OH NO! 404")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('p',{staticStyle:{"height":"15px"}}),_vm._v(" "),_c('v-btn',{attrs:{"large":"","outlined":"","color":"#34417c"},on:{"click":_vm.goHome}},[_vm._v("\n      Go to home\n    ")])],1),_vm._v(" "),_c('div',[_c('img',{staticClass:"imageCentered",attrs:{"src":__webpack_require__(644)}})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("THE LINK YOU FOLLOWED IS PROBABLY")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',[_c('b',[_vm._v("BROKEN OR THE PAGE HAS BEEN REMOVED.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 644:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/connectionFail.8541b65.png";

/***/ }),

/***/ 645:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_firebase__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__helper_paginate__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__converters_postConverter__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__helper_helper__ = __webpack_require__(31);






var _actions, _mutations;









var getDefaultState = function getDefaultState() {
  return {
    likesData: [],
    likesRefs: [],
    lastFavPublishedAt: new Date().getTime() / 1000
  };
};

var state = getDefaultState();

var getters = {
  getFavsData: function getFavsData(state) {
    return __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].compact(state.likesData);
  },
  getFavsRefs: function getFavsRefs(state) {
    return state.likesRefs;
  },
  getLastFavPublishedAt: function getLastFavPublishedAt(state) {
    return state.lastFavPublishedAt;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["d" /* GET_NEXT_LIKES */], function (_ref) {
  var getters = _ref.getters,
      dispatch = _ref.dispatch,
      commit = _ref.commit;

  return new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_promise___default.a(function (resolve) {
    var last = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].last(getters.getFavsRefs);
    var source = Object(__WEBPACK_IMPORTED_MODULE_9__helper_paginate__["b" /* getUserLikesRefsPage */])(last && last.like_at);
    source.onSnapshot({ includeMetadataChanges: true }, function (snapshot) {
      snapshot.docChanges().forEach(function (docChanged) {
        var doc = docChanged.doc;
        var likeRef = null;
        switch (docChanged.type) {
          case 'added':
            likeRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["a" /* ADD_LIKE_REF */], likeRef);
            dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["c" /* GET_LIKE_DATA_FROM_REFERENCE */], likeRef);
            break;
          case 'modified':
            likeRef = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["b" /* docToPostRef */])(doc);
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["n" /* UPDATE_LIKE_REF */], likeRef);
            break;
          case 'removed':
            commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["b" /* DELETE_LIKE */], doc.id);
            break;
          default:
            break;
        }
      });
      resolve(true);
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["c" /* GET_LIKE_DATA_FROM_REFERENCE */], function (_ref2, item) {
  var commit = _ref2.commit,
      dispatch = _ref2.dispatch,
      getters = _ref2.getters;

  item.index = item.index || Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(getters.getlikesRefs, 'docId', item.docId);
  __WEBPACK_IMPORTED_MODULE_8__firestoreDB__["e" /* postsDB */].where(__WEBPACK_IMPORTED_MODULE_6_firebase__["a" /* default */].firestore.FieldPath.documentId(), '==', item.docId).onSnapshot({ includeMetadataChanges: true }, function (snapshotDoc) {
    snapshotDoc.docChanges().forEach(function (docChanged) {
      var doc = docChanged.doc;
      var postData = Object(__WEBPACK_IMPORTED_MODULE_10__converters_postConverter__["a" /* docToPostData */])(doc, item);
      switch (docChanged.type) {
        case 'added':
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["j" /* SET_LIKES_PUBLICATION */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["l" /* UPDATE_LIKES_DATES */]);
          break;
        case 'modified':
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["j" /* SET_LIKES_PUBLICATION */], postData);
          dispatch(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["l" /* UPDATE_LIKES_DATES */]);
          break;
        case 'removed':
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["b" /* DELETE_LIKE */], doc.id);
          break;
        default:
          break;
      }
    });
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["l" /* UPDATE_LIKES_DATES */], function (_ref3) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  var twoDaysInSeconds = 172800;
  var minute = 60;
  var todaySeconds = new Date().getTime() / 1000; // today seconds
  if (todaySeconds - getters.getLastFavPublishedAt > minute) {
    getters.getFavsData.map(function (item, index) {
      if (item) {
        var seconds = item.published_at.seconds;
        var diff = todaySeconds - seconds;
        if (diff <= twoDaysInSeconds) {
          commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["g" /* REFRESH_LIKES_PUBLISHED_AT */], { item: item, index: index });
        } else return true;
      }
    });
    commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["m" /* UPDATE_LIKES_PUBLISHED_AT */], todaySeconds);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["i" /* RESET_LIKES_ACTION */], function (_ref4) {
  var commit = _ref4.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["h" /* RESET_LIKES */]);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["e" /* MERGE_LIKE */], function (_ref5, value) {
  var commit = _ref5.commit;

  commit(__WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["f" /* MERGE_LIKE_DATA */], value);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["a" /* ADD_LIKE_REF */], function (state, newElement) {
  var newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["f" /* getIndexForNewItem */])(state.likesRefs, 'like_at', newElement.like_at);
  state.likesRefs.splice(newIndexRef, 0, newElement);
  state.likesData.splice(newIndexRef, 0, null);
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["j" /* SET_LIKES_PUBLICATION */], function (state, elemData) {
  var index = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.likesRefs, 'key', elemData.key);
  if (index > -1) {
    var likesData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.likesData));
    likesData[index] = elemData;
    state.likesData = likesData;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["n" /* UPDATE_LIKE_REF */], function (state, elemRef) {
  var oldIndexRef = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.likesRefs, 'key', elemRef.key);
  var oldElemeRef = state.likesRefs[oldIndexRef];
  var elemData = null;
  var newIndexRef = -1;
  var hasIndexChanged = oldElemeRef.like_at !== elemRef.like_at;
  if (hasIndexChanged) {
    newIndexRef = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["f" /* getIndexForNewItem */])(state.likesRefs, 'like_at', elemRef.like_at);
    hasIndexChanged = newIndexRef !== oldIndexRef;
  }
  if (hasIndexChanged) {
    state.likesRefs.splice(oldIndexRef, 1);
    var elemDataList = state.likesData.splice(oldIndexRef, 1);
    elemData = elemDataList[0] || null;
    newIndexRef = newIndexRef > oldIndexRef ? newIndexRef - 1 : newIndexRef; // Testear
    state.likesRefs = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.likesRefs)), elemRef, newIndexRef);
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    state.likesData = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["a" /* addListItem */])([].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(state.likesData)), elemData, newIndexRef);
  } else {
    state.likesRefs[oldIndexRef] = elemRef;
    var likesData = state.likesData;
    elemData = likesData[oldIndexRef];
    elemData = elemData ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, elemData, elemRef) : elemData;
    likesData[oldIndexRef] = elemData;
    state.likesData = [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(likesData));
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["k" /* UPDATE_LIKES_DATA */], function (state, value) {
  state.likesData[value.index] = value;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["f" /* MERGE_LIKE_DATA */], function (state, value) {
  var key = value.key,
      data = value.data;

  var postElement = __WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].findWhere(state.likesData, { key: key });
  if (__WEBPACK_IMPORTED_MODULE_7_vue_underscore__["a" /* _ */].size(postElement) > 0) {
    postElement.like = data.like;
    state.likesData[postElement.index] = postElement;
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["g" /* REFRESH_LIKES_PUBLISHED_AT */], function (state, _ref6) {
  var item = _ref6.item,
      index = _ref6.index;

  state.likesData[index] = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.likesData[index], {
    published_at: item.published_at,
    moment: Math.random()
  });
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["m" /* UPDATE_LIKES_PUBLISHED_AT */], function (state, dateTimeSeconds) {
  state.lastFavPublishedAt = dateTimeSeconds;
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["b" /* DELETE_LIKE */], function (state, key) {
  var postIndex = Object(__WEBPACK_IMPORTED_MODULE_11__helper_helper__["e" /* getIndexForItem */])(state.likesRefs, 'key', key);
  if (postIndex > -1) {
    state.likesRefs.splice(postIndex, 1);
    state.likesData.splice(postIndex, 1);
  }
}), __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_5__actions_favQueries__["h" /* RESET_LIKES */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 646:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_webView__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__sentry_vue__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_api__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_underscore__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__analytics__ = __webpack_require__(50);





var _actions, _mutations;








var getDefaultState = function getDefaultState() {
  return {
    deviceData: [],
    pushNotif: '',
    fontSizeEm: 1
  };
};

var state = getDefaultState();

var getters = {
  getDeviceInfo: function getDeviceInfo(state) {
    return function () {
      return state.deviceData;
    };
  },
  getPushPermission: function getPushPermission(state) {
    return function () {
      return state.pushNotif;
    };
  },
  getFontSizeDeviceInfo: function getFontSizeDeviceInfo(state) {
    return state.fontSizeEm;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["a" /* ADD_USER */], function (_ref, user) {
  var commit = _ref.commit,
      getters = _ref.getters,
      dispatch = _ref.dispatch,
      state = _ref.state;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var uniqueIdUser = state.deviceData.unique_id;
    if (uniqueIdUser) {
      __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["f" /* realtimeDB */].ref('/devices/' + uniqueIdUser).update({ user_id: getters.firebaseUUID() });
    }
    resolve(true);
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["b" /* DEVICE_ACTION */], function (_ref2, device) {
  var commit = _ref2.commit,
      getters = _ref2.getters,
      dispatch = _ref2.dispatch,
      state = _ref2.state;

  // browserLog(device)
  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    try {
      var deviceInfo = device.params;
      switch (device.category) {
        case 'info':
          var uniqueId = getters.getDeviceInfo().unique_id || deviceInfo.unique_id;
          if (deviceInfo.pushNotifUpdate) {
            var today = new Date();
            deviceInfo.pushNotifUpdatedAt = today.toISOString();
          }
          if (uniqueId) {
            __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["f" /* realtimeDB */].ref('/devices/' + uniqueId).update(deviceInfo).then(function () {
              Object(__WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* apiCall */])({
                url: '/api/v1.0/firebase/notify-device',
                data: { device_id: uniqueId },
                method: 'POST'
              });
            });
          }
          commit(__WEBPACK_IMPORTED_MODULE_4__actions_webView__["e" /* SAVE_DEVICE */], deviceInfo);
          deviceInfo.fontSize && commit(__WEBPACK_IMPORTED_MODULE_4__actions_webView__["f" /* SAVE_DEVICE_INFO_FONT_SIZE */], deviceInfo.fontSize);
          break;
        case 'event':
          Object(__WEBPACK_IMPORTED_MODULE_9__analytics__["a" /* RegisterEvent */])(device.action, device.params);
          break;
      }
      resolve(deviceInfo);
    } catch (error) {
      __WEBPACK_IMPORTED_MODULE_6__sentry_vue__["a" /* captureException */](error);
      reject(error);
    }
  });
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["d" /* RESET_DEVICES_ACTION */], function (_ref3) {
  var commit = _ref3.commit,
      getters = _ref3.getters;

  commit(__WEBPACK_IMPORTED_MODULE_4__actions_webView__["c" /* RESET_DEVICES */]);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["i" /* UPDATE_DEVICE */], function (_ref4) {
  var getters = _ref4.getters,
      commit = _ref4.commit;

  return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    var uniqueId = getters.getDeviceInfo().unique_id;
    if (uniqueId) {
      __WEBPACK_IMPORTED_MODULE_5__firestoreDB__["f" /* realtimeDB */].ref('/devices/' + uniqueId).child('user_id').remove().then(function () {
        Object(__WEBPACK_IMPORTED_MODULE_7__utils_api__["a" /* apiCall */])({
          url: '/api/v1.0/firebase/notify-device',
          data: { device_id: uniqueId },
          method: 'POST'
        });
        commit(__WEBPACK_IMPORTED_MODULE_4__actions_webView__["h" /* UPDATED_DEVICE */], 'user_id');
        resolve(true);
      }).catch(function (error) {
        __WEBPACK_IMPORTED_MODULE_6__sentry_vue__["a" /* captureException */](error);
        reject(error);
      });
    }
  });
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["e" /* SAVE_DEVICE */], function (state, deviceData) {
  // browserLog({ SAVE_DEVICE_MUTATION: deviceData })
  state.deviceData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, state.deviceData, deviceData);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["g" /* SAVE_NOTIF */], function (state, value) {
  state.pushNotif = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["f" /* SAVE_DEVICE_INFO_FONT_SIZE */], function (state, value) {
  state.fontSizeEm = value;
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["c" /* RESET_DEVICES */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_4__actions_webView__["h" /* UPDATED_DEVICE */], function (state, value) {
  state.deviceData = __WEBPACK_IMPORTED_MODULE_8_vue_underscore__["a" /* _ */].omit(state.deviceData, value);
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 647:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEVICE_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RESET_DEVICES_ACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ADD_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return UPDATE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SAVE_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return SAVE_NOTIF; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RESET_DEVICES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return UPDATED_DEVICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return SAVE_DEVICE_INFO_FONT_SIZE; });
var DEVICE_ACTION = 'DEVICE_ACTION';
var RESET_DEVICES_ACTION = 'RESET_DEVICES_ACTION';
var ADD_USER = 'ADD_USER';
var UPDATE_DEVICE = 'UPDATE_DEVICE';
// Mutations
var SAVE_DEVICE = 'SAVE_DEVICE';
var SAVE_NOTIF = 'SAVE_NOTIF';
var RESET_DEVICES = 'RESET_DEVICES';
var UPDATED_DEVICE = 'UPDATED_DEVICE';
var SAVE_DEVICE_INFO_FONT_SIZE = 'SAVE_DEVICE_INFO_FONT_SIZE';

/***/ }),

/***/ 653:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__actions_visibility__ = __webpack_require__(654);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_underscore__ = __webpack_require__(12);




var _actions, _mutations;




var getDefaultState = function getDefaultState() {
  return {
    visibleIndex: [],
    visibleIndexMin: 0,
    visibleIndexMax: 0
  };
};

var state = getDefaultState();

var getters = {
  getVisibleIndex: function getVisibleIndex(state) {
    return state.visibleIndex;
  },
  getVisibleIndexMin: function getVisibleIndexMin(state) {
    return state.visibleIndexMin;
  },
  getVisibleIndexMax: function getVisibleIndexMax(state) {
    return state.visibleIndexMax;
  }
};

var actions = (_actions = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_visibility__["a" /* INSERT_VISIBLE */], function (_ref, item) {
  var commit = _ref.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__actions_visibility__["b" /* INSERT_VISIBLE_ITEM */], item);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_visibility__["c" /* REMOVE_VISIBLE */], function (_ref2, position) {
  var commit = _ref2.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__actions_visibility__["d" /* REMOVE_VISIBLE_ITEM */], position);
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_actions, __WEBPACK_IMPORTED_MODULE_3__actions_visibility__["f" /* RESET_VISIBLE_POSITIONS */], function (_ref3) {
  var commit = _ref3.commit;

  commit(__WEBPACK_IMPORTED_MODULE_3__actions_visibility__["e" /* RESET_VISIBLE_LIST */]);
}), _actions);

var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_visibility__["b" /* INSERT_VISIBLE_ITEM */], function (state, position) {
  state.visibleIndex = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.visibleIndex), [position]).sort();
  if (state.visibleIndex.length > 0) {
    state.visibleIndexMin = __WEBPACK_IMPORTED_MODULE_4_vue_underscore__["a" /* _ */].first(state.visibleIndex);
    state.visibleIndexMax = __WEBPACK_IMPORTED_MODULE_4_vue_underscore__["a" /* _ */].last(state.visibleIndex);
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_visibility__["d" /* REMOVE_VISIBLE_ITEM */], function (state, position) {
  var index = __WEBPACK_IMPORTED_MODULE_4_vue_underscore__["a" /* _ */].indexOf(state.visibleIndex, position);
  if (index > -1) {
    state.visibleIndex.splice(index, 1);
    if (state.visibleIndex.length > 0) {
      state.visibleIndexMin = __WEBPACK_IMPORTED_MODULE_4_vue_underscore__["a" /* _ */].first(state.visibleIndex);
      state.visibleIndexMax = __WEBPACK_IMPORTED_MODULE_4_vue_underscore__["a" /* _ */].last(state.visibleIndex);
    }
  }
}), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_3__actions_visibility__["e" /* RESET_VISIBLE_LIST */], function (state) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(state, getDefaultState());
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),

/***/ 654:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return INSERT_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return REMOVE_VISIBLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RESET_VISIBLE_POSITIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return INSERT_VISIBLE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return REMOVE_VISIBLE_ITEM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESET_VISIBLE_LIST; });
var INSERT_VISIBLE = 'INSERT_VISIBLE';
var REMOVE_VISIBLE = 'REMOVE_VISIBLE';
var RESET_VISIBLE_POSITIONS = 'RESET_VISIBLE_POSITIONS';
var INSERT_VISIBLE_ITEM = 'INSERT_VISIBLE_ITEM';
var REMOVE_VISIBLE_ITEM = 'REMOVE_VISIBLE_ITEM';
var RESET_VISIBLE_LIST = 'RESET_VISIBLE_LIST';

/***/ }),

/***/ 655:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showHeader)?_c('v-app-bar',{staticStyle:{"border-bottom":"1px solid #ddd","box-shadow":"none","background-color":"white"},attrs:{"app":"","fixed":"","height":"54","tile":""}},[_c('div',{staticClass:"headerMenu"},[_c('v-app-bar-nav-icon',{class:_vm.headerTitle ? 'headerBack' : 'visibleMenu',attrs:{"color":"#017BFF"},on:{"click":function($event){return _vm.onClick()}}},[_c('img',{attrs:{"src":__webpack_require__(656),"width":"12px"}}),_vm._v(" "),_c('span',{staticClass:"backSpace",style:(_vm.styles)},[_vm._v("Back")])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-title',[_c('div',{staticClass:"headerTitle",style:(_vm.styles)},[_vm._v(_vm._s(_vm.headerTitle))]),_vm._v(" "),(!_vm.headerTitle)?_c('img',{staticStyle:{"margin-top":"5px"},attrs:{"src":__webpack_require__(657),"height":"38","width":"155"}}):_vm._e()]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-app-bar-nav-icon',{directives:[{name:"show",rawName:"v-show",value:(_vm.headerTitle),expression:"headerTitle"}],attrs:{"text":""}},[_c('v-icon',{attrs:{"color":"transparent"}},[_vm._v("mdi-chevron-left")])],1)],1)]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 656:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAA/CAYAAACIEWrAAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAABWWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp0aWZmPSJodHRwOi8vbnMuYWRvYmUuY29tL3RpZmYvMS4wLyI+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpMwidZAAAFPElEQVRoBcVaTWhcVRT+7qQaLGZRpIuAuNBu7KYBpbux0CZQsEGQVhBpat1EN2JcZGbaLrqQmHShRQRNF0VbRDAoFitGokXNriAoCN1YFwHJokgXQkVCe/y+N32Zmfd37/y88UDy3jv33HO/nHfvPe98N8D/IXWbRM1WsGwPJIevJBWlPzesCsMV/hzFH/gEn9lI+5jDBTRv+3EXXxPMzgiE4Rh+xkWYuRjU8ADVbB8cVjnwWDz4fVAzqOODWDccQPP2JAdcY2R2xQN3XA2znFPvSrcdqg6DQT6csSewhXWCGfe6dVgoN0I1e4xgrgWBEVqH1mTyou/W4JSNcwL/RDB7gro6nMeSmyvnlTVsN+7hB4LZGwQGuIBzbla2gwdUt10Ec42+JwLBXMYSTsA5k/1g59CSjTEqWtphYBxW8DROxmAEaId+DUTO2k78xU0P2B/o7yoex0t4wd1ttx9MhN6zUfyDL+m42u48997hOzzK1DHrtpI2/QNSgvyToTdMJZ3nPK/jITyH192/We39AVJiVII0TGc5T+kcruMRPIuz7k6q7b6id0BKiFFiZIIMEYdfuaYPo+b+LjLvHZASomGmyPl2m8MNrucpLLrb27qcm94A1ewdgok2shy/7eqbGMEhvO1utSvz7rsHVLe3CGYuz2GH3mGDr+kgFtxmh77goTtA83aau/DpAn+tJodNgjnE/LTRUvrvwlPHvL1Bd9E3i9etwy1G8QDz0w2vbcKg43s20dZ6rJnmy/stRcGdw23OmUlO4N8KrHKb/BFq2HF+RnxMD35bQEt6kpG5njuip6F4kLod45z5lD78kXS4w6V9mKtp3TNmYXM+oIYdYWS+YO9U7ZThUWlgmpFZy2jrSpX9l8/bFCelkuWDAd62+DKPEsw3AbZek/SyVyHnIjCj3t5gDCv8hFhyXwXYBpl0RkiFnOFb9nw4oLcR+EmC0RwbmLQilFfI5Q3l8BrBXMpr7lXfBOQr5NLe5whmOa3uX1NB3fYw9N/zVe0OcueYOs6580G2PRjt4D5zkf3GA/uuMzILgbY9mVW4Sl5hhDYDe1ehBFuiNDfGhu1lpFTYhb028POjpNfW2qlP2QR3FdXh2QxFMioVfqAtugtJdb/PLUDypH0ILFGSHI7a0mLMcCeYuy6nm3rXdAKSH+3U91h9xixXsW/t1C8yUivFZuGtaUDqq1wGKB2EpI8tRup5RuqquvYr2YDktWbTjNLnvAvL9hUcYaT0uvuSVupIulHCVOJUAvXLKMFfiV6337bQIj9CcbeazXCwj/jotx3AF2N+hGJASqBKpGEyRttVvu59YeZpKz8g9VEireDNdPcMTXMfW+PCEPPatYQBkttFpxLoTNAI2vGVsMXAdikh86LTpSrX8GJxg52rjLCuQdI9ILkVyW1Q4egXh9+5Tz0TWk73BkgwavYhQc36EdGiyX4cCCEcegckfqgWFZDHg0ABv3BhHORcLKRkwid1clTRuBGDSjovTCYY0VWIqS2Q3gHJqRhUMalAWB4zMrRiasXY5kh/gORUTKoYVTGrYVKNGFsxtxnSPyA5FaMqZhU89QkRMbZibks94hSzKoZVTGuIiLkt/YhTDKuYVjGuITKUI04tazGu2ntCRExu6UecYlzFvAI3QzBFG+xQjjh1oqiJbtDVL6UfcSqpiokNL0RpOgzRt5HDj4xUfiFa6hFn1h9ZVIg6LPMT5VV1G06EYoBZhajDJSzi5fhUcTA7dTyg7yq6eCTaPJvHUzrifEpkR/O81de9vHYVojn/HfMfyVtpEmWr4O0AAAAASUVORK5CYII="

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/CHIFamilyTitle.e637a5d.png";

/***/ }),

/***/ 658:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(385);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413f8f4b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(659);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_413f8f4b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 659:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{attrs:{"padless":""}},[_c('v-bottom-navigation',{attrs:{"grow":"","flat":"","fixed":"","height":"59","id":"footer-nav"},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}},[_c('div',{staticClass:"footer-container"},[_c('v-btn',{on:{"click":function($event){return _vm.clickEventHome()}}},[_c('img',{attrs:{"src":_vm.isHomeNavActive
              ? __webpack_require__(660)
              : __webpack_require__(661),"height":"23px","width":"23px","loading":"eager"}})]),_vm._v(" "),_c('v-btn',{staticStyle:{"background":"white"},on:{"click":function($event){return _vm.clickEventNotifications()}}},[_c('v-badge',{attrs:{"overlap":"","color":"red","content":_vm.badge,"value":_vm.badge}},[_c('img',{staticStyle:{"margin-bottom":"-2px"},attrs:{"src":_vm.isNotificationNavActive
                ? __webpack_require__(662)
                : __webpack_require__(663),"height":"23px","width":"22px","loading":"eager"}})])],1),_vm._v(" "),_c('v-btn',{on:{"click":function($event){return _vm.clickEventProfile()}}},[_c('img',{attrs:{"src":_vm.isProfileNavActive
              ? __webpack_require__(664)
              : __webpack_require__(665),"height":"23","width":"23","loading":"eager"}})])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 660:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFEAAABFCAYAAAAyyAq7AAAABGdBTUEAALGPC/xhBQAABMNJREFUeAHt3F9oW1UcB/Dv7ybtbNw/6rpONB0dOuaDUDcV8WkDccNuOgV9GoIwn9oX97D2wQcRBfcH5qsgFBmIDBwOlOo2LAz/UWWIDEU2oXZd6bCdG65Z2iT3+LtJT5u0TXJvcu65NzfnPvTc5P7u75zzye/2puQ0hDBtJ8a6kcNhgPZBoBsQbSBM8f6PsKwzOJo8ByIRpiE7Y6FQDOiMiOGv8fcZ7S0eT2vZMRH9AoofwsBDf5aNCeBA8IgfTSbwb+YshNjrav6EOwz5MgYeHnEVryEoWMQ84PyXfLnu8TZXSsGK7Q8LZHCINQNK7vBABoNYN2C4IPUjKgMMD6ReROWA4YDUh+gbYPCQehALgF/xXXi3nLI/bTA3G/8RtQHKl0U/pL+I2gGDgfQPMTBA/ZD+IAYOqBdSPWJoAPVBqkUMHaAeSHWIoQX0H1INYugB/YWsH7FhAP2DrA+x4QD9gawdsWEB1UPWhtjwgGohvSNGBlAdpDfEyAGqgXSPGFnA+iHdIUYesD7I6ohNA1g7ZGXEpgOsDbI8YtMCeodcHbHpARcgiWZ5udILGOy6JGlXa1ciGsBlTnQXMezD0a3fLzuw+NBa3HN2SgD55Gbf8pUo1sIWwzg28Uw5jiXEAqCzuGg3l/BdXgfYW+6kJnr+PXb4hk3WQWS/xsnxp1abewFxCXBPHtAp323JsuW7WqJIPkdIo7Pr4ALkBmTt8zg+tnP5XK2FS3hheVv16395gsg/foOKITfCpgs4PtFTPG+rsMDSWR9oAIthSvZLIEU77NwFfHD9cRnDl7N41gBKjgptKeQmCLtfRschKMu38AOVbuEyWEX75JZWPNHZirWtK99d1ZLf5mXwV29l8MONOdye83lNvAM5JA7i5vgXfLNZ3OJY39aFvs2+v53paLNw+sAm7N3Wtti5yp3pFP/bwfAMzl29pzLtylwS8p+JpDwY1wHodDbU+0AecHbexsh4GrOZopdSjqaG1qnnHq7s7e0t+OylDuwcmsQfM9kaMnk4xYHkC0CeEZc7frY72uPofSSBdFbg6U+m8PtMRml3MZY8+0oHXnw0gf5d69F3/pbS/NWSLb3ZrhZZx3GnUpxtdHJOOaCTN8dFffoK/5nLW8/mlnyr84cWxERL4SaS4kr0a0tl7HzqRIuWKZVMQ3+PJd1H44FBVPA6GkSDqEBAQQpTiQZRgYCCFKYSDaICAQUpTCUaRAUCClKYSjSICgQUpDCVaBAVCChIYSrRV8TXKJf/FFBBJw2bwqbbbsZeuRJJ3HCTJLIxlrv5V0aE9V1kgapNjJCBWDdaLcw5XgWRPneTJKIxFzHYfsfN3CojDiaH+ffiz24SRS6G4u+6nVNlRCeLZfXzd9vNuU0YiTiLPubvIfvJ7VyqIw4kR3lp2ZtckYWP09xmbtQ4okvo7urzMvyYq+CLH/6G54/8youf9nP8GlfnFAUJ/qR08r8cRv5O48q02g/uZTdOH9OpwuqKyzfn5dPeWsKn6Nz6Kg6RpyvP26qiU2MPIk3vMObrPLr7vI0wxNFEl/n31tvI3wO8j9Mbosx/Yup+5OafY8zH+KktvELKc3XKVIG05NStNcNffHkda6xvcSR5LZBxmE6XBP4HEG7uXejaPhQAAAAASUVORK5CYII="

/***/ }),

/***/ 661:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 662:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 663:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/notifications.e69d8aa.png";

/***/ }),

/***/ 664:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 665:
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 666:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReloadRequired_vue__ = __webpack_require__(386);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ded05f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReloadRequired_vue__ = __webpack_require__(668);
function injectStyle (ssrContext) {
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-02ded05f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReloadRequired_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_02ded05f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ReloadRequired_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 667:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 668:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"500","persistent":"","content-class":"mainModal"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c('v-card',{staticClass:"cardModal",attrs:{"elevation":"0"}},[_c('div',{staticClass:"input-wrapper textAreaModal"},[_c('h2',{staticClass:"titleSection text-center"},[_vm._v("Nueva Version Encontrada")]),_vm._v(" "),_c('p',[_vm._v("Se ha detectado una nueva versión a utilizar. Es requerido actualizar")])]),_vm._v(" "),_c('div',{staticClass:"d-flex align-center justify-center"},[_c('v-btn',{attrs:{"color":"primary","depressed":""},on:{"click":function($event){return _vm.refresh()}}},[_vm._v("\n          Actualizar\n        ")])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 669:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConnectingLoader_vue__ = __webpack_require__(387);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9530ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConnectingLoader_vue__ = __webpack_require__(672);
function injectStyle (ssrContext) {
  __webpack_require__(670)
  __webpack_require__(671)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a9530ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConnectingLoader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a9530ba_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConnectingLoader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 670:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 671:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 672:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"connecting-container"},[_c('div',[_c('img',{staticClass:"imageCentered",attrs:{"src":__webpack_require__(673)}})]),_vm._v(" "),_vm._m(0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message"},[_c('h1',[_vm._v("CHI Family is connecting to CHI Servers")]),_vm._v(" "),_c('p',[_vm._v("Please wait...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 673:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/connectionInProgress.c1ecf46.png";

/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Onboarding_vue__ = __webpack_require__(388);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4732d96d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Onboarding_vue__ = __webpack_require__(675);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Onboarding_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4732d96d_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Onboarding_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 675:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"onboardingContainer"},[_c('v-col',{staticClass:"onboarding-content"},[_c('v-form',{ref:"formOnBoarding",staticClass:"form-on-boarding",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"form-inputs-wrapper"},[_c('div',{staticClass:"form-header-wrapper"},[_c('img',{staticClass:"mx-auto",attrs:{"src":__webpack_require__(389),"width":"90"}})]),_vm._v(" "),_c('v-text-field',{staticClass:"capitalize",style:(_vm.styles),attrs:{"label":"Nombre de pila","rules":_vm.rules,"disabled":_vm.getDisabledInputs('name')},on:{"change":function($event){_vm.name = $event}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{style:(_vm.styles),attrs:{"rules":_vm.emailRules,"label":"Email","disabled":_vm.getDisabledInputs('email')},on:{"change":function($event){_vm.email = $event}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('b',{style:(_vm.styles)},[_vm._v("¿Tienes hijos o los tendrás pronto?")]),_vm._v(" "),_c('v-sheet',[_c('v-switch',{style:(_vm.styles),attrs:{"inset":"","label":_vm.has_children ? 'Sí' : 'No',"disabled":_vm.getDisabledInputs('has_children')},on:{"change":function($event){_vm.has_children = $event}},model:{value:(_vm.has_children),callback:function ($$v) {_vm.has_children=$$v},expression:"has_children"}})],1),_vm._v(" "),(_vm.has_children)?_c('div',[_vm._l((_vm.children_birthdate),function(itemField,index){return _c('v-dialog',{key:("childrenBirthdate" + index),ref:"children_birthdate",refInFor:true,attrs:{"return-value":itemField.value,"persistent":"","width":"290px"},on:{"update:returnValue":function($event){return _vm.$set(itemField, "value", $event)},"update:return-value":function($event){return _vm.$set(itemField, "value", $event)}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('p',{directives:[{name:"show",rawName:"v-show",value:(index === 0),expression:"index === 0"}],style:(_vm.styles)},[_vm._v("\n                Indica la fecha de nacimiento de tus hijos\n              ")]),_vm._v(" "),_c('v-text-field',_vm._g(_vm._b({attrs:{"prepend-icon":"mdi-calendar-month-outline","readonly":"","rules":_vm.rulesRequired,"label":("Fecha de nacimiento de tu " + (_vm.children_placeholder_texts[index])),"disabled":_vm.getDisabledInputs('children_birthdate')},on:{"change":function($event){itemField.value = $event}},model:{value:(itemField.value),callback:function ($$v) {_vm.$set(itemField, "value", $$v)},expression:"itemField.value"}},'v-text-field',attrs,false),on),[_c('v-icon',{directives:[{name:"show",rawName:"v-show",value:(index > 0),expression:"index > 0"}],attrs:{"slot":"append","color":"red"},on:{"click":function($event){return _vm.remove(index)}},slot:"append"},[_vm._v("mdi-minus")])],1)]}}],null,true),model:{value:(itemField.show),callback:function ($$v) {_vm.$set(itemField, "show", $$v)},expression:"itemField.show"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"active-picker":itemField.activePicker,"scrollable":""},on:{"update:activePicker":function($event){return _vm.$set(itemField, "activePicker", $event)},"update:active-picker":function($event){return _vm.$set(itemField, "activePicker", $event)}},model:{value:(itemField.value),callback:function ($$v) {_vm.$set(itemField, "value", $$v)},expression:"itemField.value"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){itemField.show = false}}},[_vm._v("\n                Cancel\n              ")]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":function($event){return _vm.$refs.children_birthdate[index].save(itemField.value)}}},[_vm._v("\n                OK\n              ")])],1)],1)}),_vm._v(" "),(_vm.childrenBirthdateLength)?_c('div',{staticClass:"d-flex align-center mb-10",on:{"click":function($event){return _vm.add()}}},[_c('v-btn',{attrs:{"text":"","icon":""}},[_c('v-icon',{attrs:{"size":"16","color":"primary"}},[_vm._v("\n                mdi-plus\n              ")])],1),_vm._v(" "),_c('span',{staticStyle:{"color":"#1976d2","font-size":"14px"},style:(_vm.stylesAddOtheChild)},[_vm._v("Añadir otro hijo")])],1):_vm._e()],2):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-buttons-wrapper"},[_c('v-btn',{staticClass:"rounded-lg",style:(_vm.styles),attrs:{"disabled":!_vm.valid,"large":"","block":"","color":"primary"},on:{"click":_vm.validate}},[_vm._v("\n          Siguiente\n        ")])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 676:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveNotification_vue__ = __webpack_require__(390);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a93bb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveNotification_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(677)
}
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ActiveNotification_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_27a93bb8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ActiveNotification_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 677:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 678:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center align-center activeNotifications mx-30"},[_c('div',{staticClass:"text-center notification-alignment"},[_c('img',{staticClass:"mx-auto",attrs:{"src":__webpack_require__(389),"width":"60","height":"auto"}}),_vm._v(" "),_c('div',{staticClass:"pt-8"}),_vm._v(" "),_c('div',{staticClass:"text-h5 text-center font-weight-bold"},[_vm._v("¡¡Enhorabuena!!")]),_vm._v(" "),_c('div',{staticClass:"pt-8"}),_vm._v(" "),_c('img',{staticClass:"mx-auto",attrs:{"src":__webpack_require__(679),"width":"90","height":"auto"}}),_vm._v(" "),_c('div',{staticClass:"pt-6"}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","elevation":"1","color":"primary","large":""},on:{"click":_vm.activeNotifications}},[_vm._v("Activar notificaciones")])],1),_vm._v(" "),_c('v-btn',{staticClass:"primary--text lowercase",attrs:{"text":""},on:{"click":_vm.next}},[_vm._v("Las activaré en otro momento")])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column justify-center",staticStyle:{"margin":"0 auto","max-width":"260px"}},[_c('p',{staticClass:"text-left"},[_vm._v("\n        No hay nada peor que perderse una buena celebración...\n      ")]),_vm._v(" "),_c('p',{staticClass:"font-weight-bold text-left"},[_vm._v("Evítalo pulsando aquí")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 679:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/confetti.0038054.png";

/***/ }),

/***/ 680:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeNavigation_vue__ = __webpack_require__(391);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f6f24a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeNavigation_vue__ = __webpack_require__(681);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HomeNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36f6f24a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_HomeNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 681:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"test":_vm.reloadMainSite}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 682:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationsNavigation_vue__ = __webpack_require__(392);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_035c9262_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationsNavigation_vue__ = __webpack_require__(683);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotificationsNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_035c9262_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotificationsNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 683:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"test":_vm.reloadMainSite}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 684:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileNavigation_vue__ = __webpack_require__(393);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17baaaec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileNavigation_vue__ = __webpack_require__(685);
var normalizeComponent = __webpack_require__(4)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileNavigation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17baaaec_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileNavigation_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 685:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"test":_vm.reloadMainSite}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 686:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(_vm.showMainViews)?[_c('main-header',{attrs:{"showHeader":_vm.showHeader,"headerTitle":_vm.HeaderTitle,"onClick":_vm.clickBackEvent}}),_vm._v(" "),_c('v-main',{attrs:{"app":""}},[_c('div',{staticClass:"contentContainer",attrs:{"fluid":"","id":"nav"}},[_c('home-navigation',{directives:[{name:"show",rawName:"v-show",value:(_vm.isHomeNavActive),expression:"isHomeNavActive"}],ref:"homeNav",on:{"navigatorLoaded":_vm.homeLoaded}}),_vm._v(" "),_c('notifications-navigation',{directives:[{name:"show",rawName:"v-show",value:(_vm.isNotificationNavActive),expression:"isNotificationNavActive"}],ref:"notificationNav",on:{"navigatorLoaded":_vm.notiLoaded}}),_vm._v(" "),_c('profile-navigation',{directives:[{name:"show",rawName:"v-show",value:(_vm.isProfileNavActive),expression:"isProfileNavActive"}],ref:"profileNav",on:{"navigatorLoaded":_vm.profileLoaded}})],1)]),_vm._v(" "),(_vm.showMenu)?_c('main-footer',{attrs:{"isHomeNavActive":_vm.isHomeNavActive,"isNotificationNavActive":_vm.isNotificationNavActive,"isProfileNavActive":_vm.isProfileNavActive,"clickEventHome":_vm.clickEventHome,"clickEventNotifications":_vm.clickEventNotifications,"clickEventProfile":_vm.clickEventProfile}}):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.viewState === 'onboarding')?_c('onboarding'):_vm._e(),_vm._v(" "),(_vm.viewState === 'active-notification')?_c('active-notifications',{on:{"cancelAlert":_vm.viewStateCancelPushNotif}}):_vm._e(),_vm._v(" "),_c('connecting-loader',{directives:[{name:"show",rawName:"v-show",value:(_vm.showConnecting),expression:"showConnecting"}]}),_vm._v(" "),_c('reload-required')],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 687:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdi_font_css_materialdesignicons_css__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mdi_font_css_materialdesignicons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__mdi_font_css_materialdesignicons_css__);





var opts = {
  icons: {
    iconfont: 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
  }
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a(opts));

/***/ }),

/***/ 689:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 690:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 691:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_observe_visibility__ = __webpack_require__(692);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_observe_visibility__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vue_observe_visibility__["a" /* default */]);

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getUserPostsRefsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUserLikesRefsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getUserAuthorPostsRefsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getUserNotifsRefsPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getUserTagNamesRefsPage; });
/* unused harmony export paginateUserList */
/* unused harmony export paginateUserListWhere */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firestoreDB__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(47);



var getUserPostsRefsPage = function getUserPostsRefsPage(lastValue) {
  return paginateUserList('publications', 'score', 'desc', lastValue);
};

var getUserLikesRefsPage = function getUserLikesRefsPage(lastValue) {
  return paginateUserListWhere('publications', 'like_at', 'desc', lastValue, ['like', '==', true]);
};

var getUserAuthorPostsRefsPage = function getUserAuthorPostsRefsPage(lastValue, author) {
  return paginateUserListWhere('publications', 'score', 'desc', lastValue, ['author_name', '==', author]);
};

var getUserNotifsRefsPage = function getUserNotifsRefsPage(lastValue) {
  return paginateUserList('notifications', 'score', 'desc', lastValue);
};

var getUserTagNamesRefsPage = function getUserTagNamesRefsPage(lastValue, tagName) {
  return paginateUserListWhere('publications', 'score', 'desc', lastValue, ['tags', 'array-contains', tagName]);
};

var paginateUserList = function paginateUserList(collection, sortField, sortOrder, lastValue) {
  var uuid = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.firebaseUUID();
  var paginatedList = null;
  if (lastValue) {
    paginatedList = __WEBPACK_IMPORTED_MODULE_0__firestoreDB__["h" /* userDB */].doc(uuid).collection(collection).orderBy(sortField, sortOrder).startAfter(lastValue).limit(__WEBPACK_IMPORTED_MODULE_0__firestoreDB__["c" /* limitRefDB */]);
  } else {
    paginatedList = __WEBPACK_IMPORTED_MODULE_0__firestoreDB__["h" /* userDB */].doc(uuid).collection(collection).orderBy(sortField, sortOrder).limit(__WEBPACK_IMPORTED_MODULE_0__firestoreDB__["c" /* limitRefDB */]);
  }
  return paginatedList;
};

var paginateUserListWhere = function paginateUserListWhere(collection, sortField, sortOrder, lastValue, where) {
  var uuid = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.firebaseUUID();
  var paginatedList = null;
  if (lastValue) {
    paginatedList = __WEBPACK_IMPORTED_MODULE_0__firestoreDB__["h" /* userDB */].doc(uuid).collection(collection).where(where[0], where[1], where[2]).orderBy(sortField, sortOrder).startAfter(lastValue).limit(__WEBPACK_IMPORTED_MODULE_0__firestoreDB__["c" /* limitRefDB */]);
  } else {
    paginatedList = __WEBPACK_IMPORTED_MODULE_0__firestoreDB__["h" /* userDB */].doc(uuid).collection(collection).where(where[0], where[1], where[2]).orderBy(sortField, sortOrder).limit(__WEBPACK_IMPORTED_MODULE_0__firestoreDB__["c" /* limitRefDB */]);
  }
  return paginatedList;
};

/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return docToPostRef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return docToPostData; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);


var docToPostRef = function docToPostRef(doc) {
  var data = doc.data();
  return {
    docId: data.post_ref.id,
    like: data.like,
    like_date: data.like_date,
    like_at: data.like_at || 1,
    published_at: data.published_at,
    key: doc.id,
    score: data.score,
    tags: data.tags
  };
};

var docToPostData = function docToPostData(doc, item) {
  var data = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(doc.data()));
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, data, {
    authorName: data.author.name,
    key: doc.id,
    published_at: item.published_at,
    like: item.like,
    score: item.score,
    tags: item.tags
  });
};

/***/ })

},[401]);


// WEBPACK FOOTER //
// static/js/app.dba22eb2b15f5154b0c7.js